import moment from "moment";
import React, { Suspense, useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Link } from "react-router-dom";
import { getAccount, getAllGSMChartByDate, getAllMapDataInGSM, getAllMeterTotalGSMSmartMeter, getAllModemTotalGSM, getAreaById, getCircleById, getGSMSmartMeterCountStatusByGa, getDivisionById, getGaById, getGSMRSSIInDeshboardAllCountByStatus, getGSMTotalCountByTS, getmodemFirmwarTotalGSM, getmodemServiceProviderTotalGSM, getRolesById, getSubdevisionById, getGSMSmartMeterTagsWiseConsumerData, gsm_instantaneous_day_wise_graph_details, onGetGSMSmartMeterConsumerDetailsByColumn, onGetConsumerDetailsByColumnBetween, onGetGSMSmartMeterConsumerIncolumeName, getmodemMeterConnectivityTotalGSM, getmodemConnectivityTotalGSM, getGSM_BANDTotalGSM, getAllGSMEventChartByDate, getAllGSMMonthlyChartByDate, GetInstallationDateWiseGraphData, getAllGSMChartByDateSlection, getStartAndEndDateByTable, getIPVTotalINGSM, GetInstallationDateWiseGraphDataBySelectedDate, getAllGSMMonthlyChartBySelectedDate, getAllGSMEventChartBySelectedDate, getProfilNameByAccountId, getHeatbeatStatusWiseCountInGroupDashboard, getAPMTotalGSM, getBateeryPercentageAllCountByStatus, getGroupWiseConsumerStatusCount,getAllMechanicalMeterTotalGSM,getUnlockGSMConsumer,get_Instantaneous_Data_Refresh, getAllCategoryTableData} from "../../Commoncomponet/Utils";
import signal2 from '../../assets/img/secondsignal.png'
import signal3 from '../../assets/img/signal3.png'
import signal4 from '../../assets/img/signal4.png'
import signal5 from '../../assets/img/signal5.png'
import exports from '../../assets/img/export.png'
import {
	withScriptjs,
	withGoogleMap,
	GoogleMap,
	Marker,
	InfoWindow
} from "react-google-maps"
import mapicon from '../../assets/img/triangle-green.svg'
import mapRedicon from '../../assets/img/triangle-red.svg'
import { red } from "@mui/material/colors";
import { padding } from "@mui/system";
import { DatePicker, Modal, Space, Spin } from "antd";
import { Modal as BootstrapModal } from 'react-bootstrap';
import './Dashboard.css'

import Select from 'react-select';
import { BootstrapTooltip, exportExcelDownload } from "../../Commoncomponet/common";
import loaderGif from '../../assets/img/loading_chart.gif'
import jQuery from 'jquery'
import { useRef } from 'react';
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
} from 'chart.js';
import $ from 'jquery'
import { Bar, getElementsAtEvent, getElementAtEvent, getDatasetAtEvent } from 'react-chartjs-2';
import zoomPlugin from 'chartjs-plugin-zoom';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { useMemo } from "react";
import makeAnimated from 'react-select/animated';
import { Info } from "react-feather";
import { toast } from "react-toastify";
import chroma from "chroma-js";
import swal from 'sweetalert2';
window.Swal = swal;

const sum = (arr) => {
	const result = arr.reduce((total, currentValue) => total = total + currentValue, 0);
	return result
}
ChartJS.register(
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
	zoomPlugin, ChartDataLabels
);

export default function GSMSmartMeterDashboard() {
	const chartRef = useRef();
	const eventChartRef = useRef();
	const InstallChartRef = useRef();

	const GSMDATList = ['HEARTBEAT_SUCCESS_LIST', 'HEARTBEAT_FAIL_LIST', 'DAILY_SUCCESS_LIST', 'DAILY_FAIL_LIST', 'HOURLY_SUCCESS_LIST', 'HOURLY_FAIL_LIST', 'ALERT_LIST', 'EVC_MC_METER_COMM_FAIL_LIST', 'EVC_MC_METER_SR_NOT_MATCH_LIST', 'CURRENT_EVENT_LIST', 'POWER_EVENT_LIST', 'OTHER_EVENT_LIST', 'TRANSECTION_EVENT_LIST', 'NONROLLOVER_EVENT_LIST', 'CONTROL_EVENT_LIST', 'COUNT_LIST']

	const GSMEventList = ['VOLT_EVENT_LIST', 'CURRENT_EVENT_LIST', 'POWER_EVENT_LIST', 'OTHER_EVENT_LIST', 'TRANSECTION_EVENT_LIST', 'NONROLLOVER_EVENT_LIST', 'CONTROL_EVENT_LIST', 'COUNT_LIST']
	const GSMDATAConsumerCheckList = ['HEARTBEAT_TS', 'HEARTBEAT_TS', 'DAILY_TS', 'DAILY_TS', 'HOURLY_TS', 'HOURLY_TS', 'ALERT_TS', 'EVC_MC_METER_COMM_FAIL_TS', 'EVC_MC_METER_SR_NOT_MATCH', 'EMT_TS_CE', 'EMT_TS_PE', 'EMT_TS_OTHE', 'EMT_TS_TE', 'EMT_TS_NRE', 'EMT_TS_CTRLE']
	const GSMEventConsumerCheckList = ['EMT_TS_VE', 'EMT_TS_CE', 'EMT_TS_PE', 'EMT_TS_OTHE', 'EMT_TS_TE', 'EMT_TS_NRE', 'EMT_TS_CTRLE']
	const MonthList = ['MONTH_BILL_SUCCESS_LIST', 'MONTH_BILL_FAIL_LIST']
	const codeAndStatus = [{ code: 0, name: 'DLMS_ERROR_CODE_OK' }, { code: 1, name: 'DLMS_ERROR_CODE_HARDWARE_FAULT' }, { code: 2, name: 'DLMS_ERROR_CODE_TEMPORARY_FAILURE' }, { code: 3, name: 'DLMS_ERROR_CODE_READ_WRITE_DENIED ' }, { code: 4, name: 'DLMS_ERROR_CODE_UNDEFINED_OBJECT ' }, { code: 9, name: 'DLMS_ERROR_CODE_INCONSISTENT_CLASS_OR_OBJECT ' }, { code: 11, name: 'DLMS_ERROR_CODE_UNAVAILABLE_OBJECT' }, { code: 12, name: 'DLMS_ERROR_CODE_UNMATCH_TYPE' }, { code: 13, name: 'DLMS_ERROR_CODE_ACCESS_VIOLATED' }, { code: 14, name: 'DLMS_ERROR_CODE_DATA_BLOCK_UNAVAILABLE' }, { code: 15, name: 'DLMS_ERROR_CODE_LONG_GET_OR_READ_ABORTED' }, { code: 16, name: 'DLMS_ERROR_CODE_NO_LONG_GET_OR_READ_IN_PROGRESS' }, { code: 17, name: 'DLMS_ERROR_CODE_LONG_SET_OR_WRITE_ABORTED' }, { code: 18, name: 'DLMS_ERROR_CODE_NO_LONG_SET_OR_WRITE_IN_PROGRESS' }, { code: 19, name: 'DLMS_ERROR_CODE_DATA_BLOCK_NUMBER_INVALID' }, { code: 250, name: 'DLMS_ERROR_CODE_OTHER_REASON' }, { code: 251, name: 'DLMS_ERROR_CODE_UNKNOWN' }, { code: 252, name: 'DLMS_ERROR_CODE_SEND_FAILED' }, { code: 253, name: 'DLMS_ERROR_CODE_RECEIVE_FAILED' }, { code: 254, name: 'DLMS_ERROR_CODE_NOT_IMPLEMENTED' }, { code: 255, name: 'DLMS_ERROR_CODE_DLMS_SECURITY_NOT_IMPLEMENTED' }, { code: 256, name: 'DLMS_ERROR_CODE_INVALID_COMMAND' }, { code: 257, name: 'DLMS_ERROR_CODE_INVALID_BLOCK_NUMBER' }, { code: 258, name: 'DLMS_ERROR_CODE_INVALID_PARAMETER' }, { code: 259, name: 'DLMS_ERROR_CODE_NOT_INITIALIZED' }, { code: 260, name: 'DLMS_ERROR_CODE_OUTOFMEMORY' }, { code: 261, name: 'DLMS_ERROR_CODE_NOT_REPLY' }, { code: 262, name: 'DLMS_ERROR_CODE_INVALID_LOGICAL_NAME' }, { code: 263, name: 'DLMS_ERROR_CODE_INVALID_CLIENT_ADDRESS' }, { code: 264, name: 'DLMS_ERROR_CODE_INVALID_SERVER_ADDRESS' }, { code: 265, name: 'DLMS_ERROR_CODE_INVALID_DATA_FORMAT' }, { code: 267, name: 'DLMS_ERROR_CODE_INVALID_VERSION_NUMBER' }, { code: 268, name: 'DLMS_ERROR_CODE_CLIENT_ADDRESS_NO_NOT_MATCH' }, { code: 269, name: 'DLMS_ERROR_CODE_SERVER_ADDRESS_NO_NOT_MATCH' }, { code: 270, name: 'DLMS_ERROR_CODE_WRONG_CRC' }, { code: 281, name: 'DLMS_ERROR_CODE_INVALID_RESPONSE' }, { code: 278, name: 'DLMS_ERROR_CODE_INVALID_TAG' }, { code: 279, name: 'DLMS_ERROR_CODE_ENCODING_FAILED' }, { code: 280, name: 'DLMS_ERROR_CODE_REJECTED_PERMAMENT' }, { code: 281, name: 'DLMS_ERROR_CODE_REJECTED_TRANSIENT' }, { code: 282, name: 'DLMS_ERROR_CODE_NO_REASON_GIVEN' }, { code: 283, name: 'DLMS_ERROR_CODE_APPLICATION_CONTEXT_NAME_NOT_SUPPORTED' }, { code: 284, name: 'DLMS_ERROR_CODE_AUTHENTICATION_MECHANISM_NAME_NOT_RECOGNISED' }, { code: 285, name: 'DLMS_ERROR_CODE_AUTHENTICATION_MECHANISM_NAME_REQUIRED' }, { code: 286, name: 'DLMS_ERROR_CODE_AUTHENTICATION_FAILURE' }, { code: 287, name: 'DLMS_ERROR_CODE_AUTHENTICATION_REQUIRED' }, { code: 288, name: 'DLMS_ERROR_CODE_INVALID_FRAME_NUMBER' }, { code: 289, name: 'DLMS_ERROR_CODE_INVALID_DATE_TIME' }, { code: 289, name: 'DLMS_ERROR_CODE_INVALID_DATE_TIME' }, { code: 290, name: 'DLMS_ERROR_CODE_INVOCATION_COUNTER_TOO_SMALL' }, { code: 291, name: 'DLMS_ERROR_CODE_INVALID_DATE_TIME' }, { code: 292, name: 'DLMS_ERROR_CODE_INVALID_DECIPHERING_ERROR' }, { code: 293, name: 'DLMS_ERROR_CODE_INVALID_SECURITY_SUITE' }]
	const [dateInLong, setDateInLong] = useState([]);
	const [DateEventInLong, setDateEventInLong] = useState([])
	const [AllGSMMonthChartData, setAllGSMMonthChartData] = useState({ month_success: [], month_fail: [], SRNO: [] })
	const [DateMonthInLong, setDateMonthInLong] = useState([]);
	const [AllGSMEventChartData, setAllGSMEventChartData] = useState({ volt: [], current: [], power: [], other: [], transection: [], nonrollover: [], control: [], count: [], SRNO: [] })
	const [AllGSMChartData, setAllGSMChartData] = useState({ heartbeat_success: [], heartbeat_fail: [], daily_success: [], daily_fail: [], load_success: [], load_fail: [], SRNO: [] });
	const [tableData, setTableData] = useState([]);
	const [seriesModem, setseriesModem] = useState([])
	const [serviceProvid, setserviceProvid] = useState({ series: [], category: [] })
	const [MCOMST, setMCOMST] = useState({ series: [], category: [], code: [] })
	const [tagsCount, settagsCount] = useState({ series: [], category: [], id: [] })
	const [installData, setInstallData] = useState([])
	const [installLoad,setinstallLoad]=useState(false)
	const [DEVICE_STATUS, setDEVICE_STATUS] = useState({ series: [], categories: [] })
	const [UnlockBrand, setUnlockBrand] = useState({ series: [], categories: [] })
	const [GSM_BAND, setGSM_BAND] = useState({ series: [], categories: [] })
	const [categoryModem, setcategoryModem] = useState([])
	const [seriesMeter, setseriesMeter] = useState([])
	const [seriesMechanicalMeter, setseriesMechanicalMeter] = useState([])
	const [categoryMechanicalMeter, setcategoryMechanicalMeter] = useState([])
	const [categoryMeter, setcategoryMeter] = useState([])
	const [AllData, setAllData] = useState({});
	const [BlankData, setBlankData] = useState(['Active(Live)','Active(Temporary Disconnection)','Inactive(Permanent Disconnection)','Pending Configuration','Under Maintanance']);
	const [loader, setLoader] = useState(false);
	const [mapInfo, setMapInfo] = useState([])
	const [categoryFirmwar, setcategoryFirmwar] = useState([])
	const [seriesFirmwar, setseriesFirmwar] = useState([])
	const [testing, setTesting] = useState([])
	const [chartClickData, setchartClickData] = useState([])
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [ModalLoad,setModalLoad]=useState(false)
	const [tabShow, settabShow] = useState(false)
	const [isLastModalVisible, setIsLastModalVisible] = useState(false);
	const [ModelId, setModelId] = useState('')
	const [ColorText, setColorText] = useState('')
	const [ModemId, setModemId] = useState([])
	const [TableData, setTableDataInApi] = useState([])
	const [MeterId, setMeterId] = useState([])
	const [MechancalMeterId, setMechancalMeterId] = useState([])
	const [SubdevisionData, setSubdevisionData] = useState([]);
	const [DivisionData, setDivisionData] = useState([]);
	const [CircleData, setCircleData] = useState([]);
	const [GaData, setGaData] = useState([]);
	const [AccounData, setAccountData] = useState([]);
	const [AreaData, setAreaData] = useState([]);
	const [permision, setpermision] = useState({});
	const [letest24, setletest24] = useState({});
	const [categoryRSSI, setcategoryRSSI] = useState([])
	const [categoryBAT, setcategoryBAT] = useState([])
	const serisBAT = ['0 - 20', '21 - 40', '41 - 60', '61 - 80', '81 - 100']
	const [inputSeen, setinputSeen] = useState('24')
	const [seriesRSSI, setseriesRSSI] = useState(["Marginal (2-9)", "OK (10-14)", "Good (15-19)", "Excellent (20-31)"])
	const [Profile, setProfile] = useState({ account: "", ga: "", circle: "", division: "", subdivision: "", area: "" });
	const [expandedModelHeader, setExpandedModelHeader] = useState('')
	const [expireDate, setExpireDate] = useState({})
	const [isExpandedModalOpen, setisExpandedModalOpen] = useState(false)
	const [expandedChartData, setexpandedChartData] = useState({ total: { heartbeat_success: [], heartbeat_fail: [], daily_success: [], daily_fail: [], load_success: [], load_fail: [], SRNO: [] }, date: [] })
	const [IPV, setIPV] = useState({ IPV: [], categories: ['IPV4', 'IPV6', 'IPV4V6(auto)'] })
	const [exInstallationChartData, setExInstallationChartData] = useState({ barData: [], date: [] })
	const [exGSMCountGroup,setexGSMCountGroup]=useState({ total: { active_Live_count: [],active_TD_count: [], inactive_count: [], undermaintanace_count: [], pending_count: [], SRNO: [] }, date: [] })
	const [exEventChartData, setExEventChartData] = useState({ total: { volt: [], current: [], power: [], other: [], transection: [], nonrollover: [], control: [], count: [], SRNO: [] }, date: [] })
	const [exMonthBillChartData, setExMonthBillChartData] = useState({ total: { month_success: [], month_fail: [], SRNO: [] }, date: [] })
	const [datesInmap, setdatesInmap] = useState({ start: '', end: '' })
	const [HeatbeatStatus, setHeatbeatStatus] = useState({})
	const [APM, setAPM] = useState({ series: [], category: [] })
	const [ChartLoader, setChartLoader] = useState(false)
	const [dates, setDates] = useState({ start: '', end: '' })
	const [MeterDetails,setMeterDetails]=useState([])
	const [AllCategory,setAllCategory]=useState({})
	const btnColor = ['#4f5ece', '#f59e0b', '#fc544b', '#3abaf4', '#54ca68', '#191d21', '#7c5295', '#4f5ece']

	const userInfo = JSON.parse(window.localStorage.getItem("user_info"));

	const onChange = (date, dateString) => {
		setDates({ ...dates, start: dateString })
	};
	const onChanges = (date, dateString) => {
		setDates({ ...dates, end: dateString })
	};
	const onChangeMap = (date, dateString) => {
		setdatesInmap({ ...datesInmap, start: dateString })
	};
	const onChangesMap = (date, dateString) => {
		setdatesInmap({ ...datesInmap, end: dateString })
	};
	const onExpandButton = (tableName, col, header) => {
		if (header == 'Installation Date Wise Chart') {
			setExpireDate({ start_date: '', endDate: new Date(Date.now() + 1 * 24 * 60 * 60 * 1000) })
			setisExpandedModalOpen(true)
		}
		else {
			ongetStartAndEndDateByTable(tableName, col)
		}
		// onGetTableNameWiseChartDataBy15Date()
		setExpandedModelHeader(header)
	}
	const handleExpandedModal = () => {
		setisExpandedModalOpen(false);
		setexpandedChartData({ total: {}, date: [] })
		setExInstallationChartData({ barData: [], date: [] })
		setExEventChartData({ total: {}, date: [] })
		setExMonthBillChartData({ total: {}, date: [] })
		setexGSMCountGroup({ total: {}, date: [] })
		if (myChart != undefined) {
			myChart.destroy()
		}
		setChartLoader(false)
		setDates({ start: '', end: '' })
	}

	const onget_Instantaneous_Data_Refresh=async()=>{
		const data=await get_Instantaneous_Data_Refresh()
		if(data.success==true){
			swal.fire('', 'Script Started', 'success')
		}else if(data?.err?.response?.status===403) {
			swal.fire('', 'Script is Running', 'error')

		}else if(data?.err?.response?.status===400){
			swal.fire('', "Last Refreshed Less than 1 Hour ago, So Can't Refresh", 'error')

		}else{

			swal.fire('', 'Something Want Wrong', 'error')
		}
	}

	const ongetStartAndEndDateByTable = async (tableName, col) => {
		console.log("Wanted to check if this is calling or not")
		document.body.style.cursor = 'want'
		const data = await getStartAndEndDateByTable({ tableName: tableName, col: col })
		if (data.success === true) {

			console.log("Expiry Dates == ", data.data)
			setExpireDate(data.data)
			setisExpandedModalOpen(true)
			document.body.style.cursor = 'default'
		} else {
			console.log("something want wrong")
			document.body.style.cursor = 'default'
		}
	}

	const onExpandSubmitClick = async () => {

		const x = new Date(moment(dates.start,'DD-MM-YYYY').format('YYYY-MM-DD'));
const y = new Date(moment(dates.end,'DD-MM-YYYY').format('YYYY-MM-DD'));
console.log(x>y,x,y);
			if(x>y){
			return	toast.warn('"Start Date" Must be Less than or Equal to "End Date"')
			}
		if (expandedModelHeader == 'Installation Date Wise Chart') {
			onGetexInstallationChartData()

		} else if (expandedModelHeader == 'GSM Instantaneous Count') {
			onGetexInstantData()
		}
		else if (expandedModelHeader == 'GSM Event Count') {
			onGetexEventData()
		}
		else if (expandedModelHeader == 'GSM Month Bill Count') {
			onGetexMonthBillData()
		}
		else if (expandedModelHeader == 'GSM Consumer Status') {
			onGetGSMStatusWiseCount()
		}
	}

	const onGetexInstallationChartData = async () => {
		setChartLoader(true)
		const data = await GetInstallationDateWiseGraphDataBySelectedDate({ start: moment(dates.start, "DD-MM-YYYY").format("YYYY-MM-DD"), end: moment(dates.end, "DD-MM-YYYY").format("YYYY-MM-DD"),CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, CATEGORY3: Profile.division, CATEGORY4: Profile.subdivision, CATEGORY5: Profile.area, ROLES: userInfo?.ROLE, serach: Profile.account === '' && Profile.ga === '' && Profile.circle === '' && Profile.division === '' && Profile.subdivision === '' && Profile.area === '' ? false : true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view }  })

		if (data.success === true) {
			setExInstallationChartData({ barData: data.data.data.map((item => item?.total)), date: data.data.data.map((item) => (moment(item.dates).format("DD-MM-YYYY"))) })
			setChartLoader(false)
		}
		else {
			console.log('something want wrong')
			setChartLoader(false)
		}
	}

	const onGetexInstantData = async () => {
		setChartLoader(true)
		const data = await getAllGSMChartByDateSlection({ start: moment(dates.start, "DD-MM-YYYY").format("YYYY-MM-DD"), end: moment(dates.end, "DD-MM-YYYY").format("YYYY-MM-DD"), CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, CATEGORY3: Profile.division, CATEGORY4: Profile.subdivision, CATEGORY5: Profile.area, ROLES: userInfo?.ROLE, serach: Profile.account === '' && Profile.ga === '' && Profile.circle === '' && Profile.division === '' && Profile.subdivision === '' && Profile.area === '' ? false : true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } })
		if (data.success === true) {
			const ChartArray = data.data.data;
			const obj = { heartbeat_success: ChartArray.map((item) => (item?.heartbeat_success)), heartbeat_fail: ChartArray.map((item) => (item?.heartbeat_fail)), daily_success: ChartArray.map((item) => (item?.daily_success)), daily_fail: ChartArray.map((item) => (item?.daily_fail)), load_success: ChartArray.map((item) => (item?.load_success)), load_fail: ChartArray.map((item) => (item?.load_fail)), alert_count: ChartArray.map((item) => (item?.alert_count)),meter_comm_fail_count:ChartArray.map((item) => (item?.meter_comm_fail_count)), SRNO: ChartArray.map((item) => (item?.SRNO)) }
			setexpandedChartData({ total: obj, date: data.data.data.map((item) => (item.CREATED_AT.split('T')[1]?moment.utc(item.CREATED_AT).format('DD-MM-YYYY'):item.CREATED_AT))})
			setChartLoader(false)
		} else {
			console.log('something want wrong')
			setChartLoader(false)
		}
	}
	const onGetexEventData = async () => {
		setChartLoader(true)
		const data = await getAllGSMEventChartBySelectedDate({ start: moment(dates.start, "DD-MM-YYYY").format("YYYY-MM-DD"), end: moment(dates.end, "DD-MM-YYYY").format("YYYY-MM-DD"), CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, CATEGORY3: Profile.division, CATEGORY4: Profile.subdivision, CATEGORY5: Profile.area, ROLES: userInfo?.ROLE, serach: Profile.account === '' && Profile.ga === '' && Profile.circle === '' && Profile.division === '' && Profile.subdivision === '' && Profile.area === '' ? false : true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } })
		if (data.success === true) {
			console.log("Event Data ===", data.data.data)
			const ChartArray = data.data.data;
			const obj = { volt: ChartArray.map((item) => (item?.volt)), current: ChartArray.map((item) => (item?.current)), power: ChartArray.map((item) => (item?.power)), other: ChartArray.map((item) => (item?.other)), transection: ChartArray.map((item) => (item?.transection)), nonrollover: ChartArray.map((item) => (item?.nonrollover)), control: ChartArray.map((item) => (item?.control)), count: ChartArray.map((item) => (item?.count || 0)), SRNO: ChartArray.map((item) => (item?.SRNO)) }
			setExEventChartData({ total: obj, date: data.data.data.map((item) => (moment.utc(item.CREATED_AT).add(-moment().utcOffset(), "m").format("DD-MM-YYYY"))) })
			setChartLoader(false)
		} else {
			console.log('something want wrong')
			setChartLoader(false)
		}
	}
	const onGetexMonthBillData = async () => {
		setChartLoader(true)
		const data = await getAllGSMMonthlyChartBySelectedDate({ start: dates.start, end: dates.end, CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, CATEGORY3: Profile.division, CATEGORY4: Profile.subdivision, CATEGORY5: Profile.area, ROLES: userInfo?.ROLE, serach: Profile.account === '' && Profile.ga === '' && Profile.circle === '' && Profile.division === '' && Profile.subdivision === '' && Profile.area === '' ? false : true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } })
		if (data.success === true) {
			console.log("Month Bill Data == ", data.data.data)
			const ChartArray = data.data.data;
			const obj = { month_success: ChartArray.map((item) => (item?.month_success)), month_fail: ChartArray.map((item) => (item?.month_fail)), SRNO: ChartArray.map((item) => (item?.SRNO)) }
			setExMonthBillChartData({ total: obj, date: data.data.data.map((item) => ([item.CREATED_AT])) })
			setChartLoader(false)
		} else {
			console.log('something want wrong')
			setChartLoader(false)
		}
	}



	const ongetAllGSMChartByDate = async (info) => {
		setAllGSMChartData({ heartbeat_success: [], heartbeat_fail: [], daily_success: [], daily_fail: [], load_success: [], load_fail: [], SRNO: [] })

		setLoader(true);
		setLoader(false);
		const data = await getAllGSMChartByDate(info || {});
		if (data.success === true) {
			const ChartArray = data.data.data;
			const obj = { heartbeat_success: ChartArray.map((item) => (item?.heartbeat_success)), heartbeat_fail: ChartArray.map((item) => (item?.heartbeat_fail)), daily_success: ChartArray.map((item) => (item?.daily_success)), daily_fail: ChartArray.map((item) => (item?.daily_fail)), load_success: ChartArray.map((item) => (item?.load_success)), load_fail: ChartArray.map((item) => (item?.load_fail)), alert_count: ChartArray.map((item) => (item?.alert_count)),meter_comm_fail_count:ChartArray.map((item) => (item?.meter_comm_fail_count)),NOT_METER_SRNO:ChartArray.map((item) => (item?.NOT_METER_SRNO)), SRNO: ChartArray.map((item) => (item?.SRNO)),ENTRYTS:ChartArray[5]?.ENTRYTS }
			setAllGSMChartData(obj)
			const DateArray = ChartArray.map((item) => ([item.CREATED_AT.split('T')[1]?moment.utc(item.CREATED_AT).format('DD-MM-YYYY'):item.CREATED_AT]))
			setDateInLong(DateArray);
		} else {
			console.log("something want wrong");
			setLoader(false);
		}
	};

	const onGetGSMStatusWiseCount=async()=>{
		const data=await getGroupWiseConsumerStatusCount({ start: moment(dates.start, "DD-MM-YYYY").format("YYYY-MM-DD"), end: moment(dates.end, "DD-MM-YYYY").format("YYYY-MM-DD"), CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, CATEGORY3: Profile.division, CATEGORY4: Profile.subdivision, CATEGORY5: Profile.area, ROLES: userInfo?.ROLE, serach: Profile.account === '' && Profile.ga === '' && Profile.circle === '' && Profile.division === '' && Profile.subdivision === '' && Profile.area === '' ? false : true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } })

		if(data.success==true){
			const ChartArray = data.data.data;
			const obj = { active_Live_count: ChartArray.map((item) => (item?.active_Live_count)),active_TD_count: ChartArray.map((item) => (item?.active_TD_count)), inactive_count: ChartArray.map((item) => (item?.inactive_count)), undermaintanace_count: ChartArray.map((item) => (item?.undermaintanace_count)), pending_count: ChartArray.map((item) => (item?.pending_count)), SRNO: ChartArray.map((item) => (item?.SRNO))}
			setexGSMCountGroup({ total: obj, date: data.data.data.map((item) => (item.CREATED_AT.split('T')[1]?moment.utc(item.CREATED_AT).format('DD-MM-YYYY'):item.CREATED_AT))})
			console.log(data.data)
		}else{
			console.log("something want wrong");
		}
	}

	const ongetCountStatusByGa = async (info) => {
		setTableData([])
		const data = await getGSMSmartMeterCountStatusByGa(info);
		if (data.success === true) {
			const StatusArray=data.data.data
			setTableData([StatusArray?.active_Live_length||0,StatusArray?.active_TD_length||0,StatusArray?.InActive_length||0,StatusArray?.Pandding_length||0,StatusArray?.Maintenance||0]);
		} else {
			console.log("something want warong");
		}
	};
	const ongetAllModemTotalGSM = async (info) => {
		setseriesModem([]);

		const data = await getAllModemTotalGSM(info);
		if (data.success === true) {
			const MID = data.data.data.map((item) => (item?.MODEM_TYPE))
			const MSID = data.data.data.map((item) => (item?.Modem_length))
			const MCID = data.data.data.map((item) => (item?.MODEM_PROFILE_NAME + '(' + item?.Modem_length + ')'))
			setModemId(MID)
			setseriesModem(MSID);
			setcategoryModem(MCID);
		} else {
			console.log("something want warong");
		}
	};

	const ongetServiceProviderTotalGSM = async (info) => {
		setserviceProvid({ series: [], category: [] });

		const data = await getmodemServiceProviderTotalGSM(info);
		if (data.success === true) {
			var series = []
			var category = []
			var count = 0
			data.data.data.map((item) => {
				if (item?.SIM_NWKP == 'IDEA' || item?.SIM_NWKP == 'Vodafone IN' ||item?.SIM_NWKP == 'Vi India') {
					count = count + item?.total
				} else {
					series.push(item?.total)
					category.push(item?.SIM_NWKP + '(' + item?.total + ')')
				}
			}
			)
			const obj = { series: [...series, count], category: [...category, 'VI' + `(${count})`] }
			setserviceProvid(obj);
		} else {
			console.log("something want warong");
		}
	}

	const ongetmodemMeterConnectivityTotalGSM = async (info) => {
		setMCOMST({ series: [], category: [], code: [] })
		const data = await getmodemMeterConnectivityTotalGSM(info);
		if (data.success === true) {
			const obj = { series: data.data.data.map((item) => (item?.total)), category: data.data.data.length > 0 && data.data.data.map((item) => (codeAndStatus.filter((items) => (items?.code == item?.MCOMST))[0]?.name + '(' + item?.total + ')')), code: data.data.data.map((item) => (item?.MCOMST)) }
			setMCOMST(obj);
		} else {
			console.log("something want warong");
		}
	};
	// const ongetmodemConnectivityTotalGSM = async (info) => {
	// 	setDEVICE_STATUS({ series: [], categories: [] })
	// 	const data = await getmodemConnectivityTotalGSM(info);
	// 	if (data.success === true) {
	// 		const obj = { series: data.data.data.map((item) => (item?.total)), categories: data.data.data.map((item) => (item?.DEVICE_STATUS+'('+item?.total+')')) }
	// 		setDEVICE_STATUS(obj);
	// 	} else {
	// 		console.log("something want warong");
	// 	}
	// }
	const ongetGSM_BANDTotalGSM = async (info) => {
		setGSM_BAND({ series: [], categories: [] })
		const data = await getGSM_BANDTotalGSM(info);
		if (data.success === true) {
			const obj = { series: data.data.data.map((item) => (item?.total)), categories: data.data.data.map((item) => (item?.GSM_BAND + '(' + item?.total + ')')) }
			setGSM_BAND(obj);
		} else {
			console.log("something want warong");
		}
	}

	const ongetUnlockGSMConsumer = async (info) => {
		setUnlockBrand({ series: [], categories: [] })
		const data = await getUnlockGSMConsumer(info);
		if (data.success === true) {
			const obj = { series: [data?.data?.data?.locked||0,data?.data?.data?.unlocked||0], categories: ["Locked"+'('+(data?.data?.data?.locked||0)+')',"Unlocked"+'('+(data?.data?.data?.unlocked||0)+')'] }
			setUnlockBrand(obj);
		} else {
			setUnlockBrand({ series: [0,0], categories: ["Locked","Unlocked"] });
			console.log("something want warong");
		}
	}
	const ongetAPMTotalGSM = async (info) => {
		setAPM({ series: [], category: [] })
		const data = await getAPMTotalGSM(info);
		if (data.success === true) {
			const obj = { series: data.data.data.map((item) => (item?.total)), category: data.data.data.map((item) => (item?.APN == '' ? 'Not Available' + '(' + item?.total + ')' : item?.APN + '(' + item?.total + ')')) }
			setAPM(obj);
		} else {
			console.log("something want warong");
		}
	}
	const ongetAllMeterTotalGSM = async (info) => {
		setseriesMeter([])
		setcategoryMeter([])
		const data = await getAllMeterTotalGSMSmartMeter(info);

		if (data.success === true) {
			setMeterId(data.data.data.map((item) => (item?.METER_TYPE)))
			setseriesMeter(data.data.data.map((item) => (item?.Meter_length)));
			setcategoryMeter(data.data.data.map((item) => (item?.METER_PROFILE_NAME + ' - ' + item?.Meter_length)));
			setMeterDetails(data.data.data)
		} else {
			console.log("something want warong");
		}
	};

	const ongetAllMechanicalMeterTotalGSM = async (info) => {
		setseriesMechanicalMeter([])
		setcategoryMechanicalMeter([])
		const data = await getAllMechanicalMeterTotalGSM(info);

		if (data.success === true) {
			setMechancalMeterId(data.data.data.map((item) => (item?.MC_TYPE)))
			setseriesMechanicalMeter(data.data.data.map((item) => (item?.MC_length)));
			setcategoryMechanicalMeter(data.data.data.map((item) => (item?.MC_PROFILE_NAME + ' - ' + item?.MC_length)));
		} else {
			console.log("something want warong");
		}
	};
	const ongetAllMapDataInGSM = async (info) => {
		setMapInfo([])
		const data = await getAllMapDataInGSM(info)
		if (data.success == true) {
			setMapInfo(data.data.data)
		} else {
			console.log('something want wrong')
		}
	}

	const ongetmodemFirmwarTotalGSM = async (info) => {
		setseriesFirmwar([])
		setcategoryFirmwar([])
		const data = await getmodemFirmwarTotalGSM(info);
		if (data.success === true) {
			setseriesFirmwar(data.data.data.map((item) => (item?.total)));
			setcategoryFirmwar(data.data.data.map((item) => (item?.modem_firmware + '(' + item?.total + ')' || '')));
		} else {
			console.log("something want warong");
		}
	}
	const ongetTagsWiseConsumerData = async (info) => {
		settagsCount({ ...tagsCount, series: [], category: [], id: [] })
		const data = await getGSMSmartMeterTagsWiseConsumerData(info);
		if (data.success === true) {
			var seri = []
			var category = []
			var id = []
			data.data.data.map((item) => {
				if (item?.total != 0) {
					seri.push(item?.total)
					category.push(item?.TAG_NAME + '(' + item?.total + ')')
					id.push(item?.UNIQUE_ID)
				}
			})
			const obj = { series: seri, category: category, id: id }
			settagsCount(obj)
		} else {
			console.log("something want warong");
		}
	}

	const onGetInstallationDateWiseGraphData = async (info) => {
		setInstallData([])
		setinstallLoad(true)
		const data = await GetInstallationDateWiseGraphData(info);
		if (data.success === true) {
			setInstallData(data.data.data)
		setinstallLoad(false)

		} else {
			console.log("something want warong");
		setinstallLoad(false)

		}
	}

	const ongetIPVTotalINGSM = async (info) => {
		setIPV({ ...IPV, IPV: [] })
		const data = await getIPVTotalINGSM(info);
		if (data.success === true) {
			setIPV({ ...IPV, IPV: [data?.data?.data?.IPV4, data?.data?.data?.IPV6, data?.data?.data?.IPV4V6], categories: ['IPV4' + '(' + data?.data?.data?.IPV4 + ')', 'IPV6' + '(' + data?.data?.data?.IPV6 + ')', 'IPV4V6(auto)' + '(' + data?.data?.data?.IPV4V6 + ')','null'+'('+data?.data?.data?.null_count+')'] })
		} else {
			console.log("something want warong");
		}
	}
	const ongetAllRSSITotalGSM = async (info) => {
		setcategoryRSSI([])
		const data = await getGSMRSSIInDeshboardAllCountByStatus(info);
		if (data.success === true) {
			setcategoryRSSI(data.data.data);
		} else {
			console.log("something want warong");
		}
	};
	const ongetAllBatteryTotalGSM = async (info) => {
		setcategoryBAT([])
		const data = await getBateeryPercentageAllCountByStatus(info);
		if (data.success === true) {
			setcategoryBAT(data.data.data);
		} else {
			console.log("something want warong");
		}
	};
	const onHandaleSelection = async () => {
		const data = await getAccount();
		if (data.success === true) {
			setAccountData(data.data.data);
		} else {
			console.log("somthing want wrong");
		}
	};
	const onHandaleRoles = async () => {
		const data = await getRolesById(userInfo?.ROLE);
		if (data.success === true) {
			const obj = data.data.data[0];
			setpermision({
				...obj,
				ROLES_PERMISSIONS_CATEGORY0: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY0),
				ROLES_PERMISSIONS_CATEGORY5: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY5),
				ROLES_PERMISSIONS_CATEGORY2: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY2),
				ROLES_PERMISSIONS_CATEGORY3: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY3),
				ROLES_PERMISSIONS_CATEGORY1: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY1),
				ROLES_PERMISSIONS_CATEGORY4: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY4),
				ROLES_OTHER_PERMISSIONS: JSON.parse(obj.ROLES_OTHER_PERMISSIONS)
			});
			const permissionViewCard = JSON.parse(obj?.ROLES_OTHER_PERMISSIONS)
			const infoRolesObj = { ROLES: userInfo?.ROLE, Profile: { CATEGORY0: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY0).CATEGORY0_view, CATEGORY1: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY1).CATEGORY1_view, CATEGORY2: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY2).CATEGORY2_view, CATEGORY3: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY3).CATEGORY3_view, CATEGORY4: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY4).CATEGORY4_view, CATEGORY5: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY5).CATEGORY5_view } }
			onHandaleSelection()
			ongetCountStatusByGa(infoRolesObj)
			if (permissionViewCard?.GSM_GROUP_DASH?.MODEM?.view?.filter((item) => (item == 'Meter_Profile')).length > 0 || userInfo?.ROLE == 'ROLE1650614500708') {
				ongetAllMeterTotalGSM(infoRolesObj)
			}
			if (permissionViewCard?.GSM_GROUP_DASH?.MODEM?.view?.filter((item) => (item == 'Tags')).length > 0 || userInfo?.ROLE == 'ROLE1650614500708') {
				ongetTagsWiseConsumerData(infoRolesObj)

			}
			// ongetAllMapDataInGSM(infoRolesObj)
		} else {
			console.log("something want wrong");
		}
	};

	const ongetHeatbeatStatusWiseCountInGroupDashboard = async (info) => {
		setHeatbeatStatus({})
		const data = await getHeatbeatStatusWiseCountInGroupDashboard(info)
		if (data.success === true) {
			setHeatbeatStatus(data.data.data)
		} else {
			console.log('something wait wrong')
		}
	}

	const onChangesProfileWiseSerch = (info) => {
		// ongetAllMapDataInGSM(info)
		ongetCountStatusByGa(info)
		if (permision?.ROLES_OTHER_PERMISSIONS?.GSM_GROUP_DASH?.MODEM?.view?.filter((item) => (item == 'Meter_Profile')).length > 0 || userInfo?.ROLE == 'ROLE1650614500708') {
			ongetAllMeterTotalGSM(info)
		}
		if (permision?.ROLES_OTHER_PERMISSIONS?.GSM_GROUP_DASH?.MODEM?.view?.filter((item) => (item == 'Tags')).length > 0 || userInfo?.ROLE == 'ROLE1650614500708') {
			ongetTagsWiseConsumerData(info)
		}
	}
	const ongetGSMTotalCountByTS = async (info) => {
		setletest24({})
		const data = await getGSMTotalCountByTS(info)
		if (data.success === true) {
			setletest24(data.data.data)
		} else {
			console.log('something want wrong')
		}
	}
	const ongetAllCategoryTableData = async (info) => {
		const data = await getAllCategoryTableData({})
		if (data.success === true) {
			setAllCategory(data.data.data)
		} else {
			console.log('something want wrong')
		}
	}
	useEffect(() => {
		jQuery.event.special.touchstart = {
			setup: function (_, ns, handle) {
				if (ns.includes("noPreventDefault")) {
					this.addEventListener("touchstart", handle, { passive: false });
				} else {
					this.addEventListener("touchstart", handle, { passive: true });
				}
			}
		};
		ongetAllCategoryTableData()
		onHandaleRoles()
		$(function () {
			$('[data-toggle="tooltip"]').tooltip()
		})
	}, []);


	const onHandalGsmChart = async (col, srno, changeTable) => {
		setModalLoad(true)
		setIsModalVisible(true)
		setModelId(`${col}`)
		setTimeout(async () => {
			settabShow(true)
			const data = await gsm_instantaneous_day_wise_graph_details({ colName: col, SRNO: srno, changeTable: changeTable, CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, CATEGORY3: Profile.division, CATEGORY4: Profile.subdivision, CATEGORY5: Profile.area, ROLES: userInfo?.ROLE, serach: Profile.account === '' && Profile.ga === '' && Profile.circle === '' && Profile.division === '' && Profile.subdivision === '' && Profile.area === '' ? false : true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } })
			if (data.success === true) {
				setModalLoad(false)
				setTableDataInApi(JSON.parse(data.data.data[0][col] || '[]').map((item) => ({ UNIQUE_ID: item?.UNIQUE_ID, DEVICE_SERIAL_NO: item?.DEVICE_SERIAL_NO, address_compony_name: item?.address_compony_name, RSSI: item?.HEARTBEAT_LAST_DATA?.GSM_RSSI,CAT0_ID:item?.Profile?.CATEGORY0,CAT1_ID:item?.Profile?.CATEGORY1,CAT2_ID:item?.Profile?.CATEGORY2,CAT3_ID:item?.Profile?.CATEGORY3,CAT4_ID:item?.Profile?.CATEGORY4,CAT5_ID:item?.Profile?.CATEGORY5 })))
			} else {
				console.log('something want wrong')
				setModalLoad(false)

			}
		}, 100);
	}

	const GetConsumerIncolumeName = async (isbetween, col, colname, value) => {
		setModelId(`${colname}`)
		setModalLoad(true)
		setIsModalVisible(true)

		console.log(Profile);
		const data = await onGetGSMSmartMeterConsumerIncolumeName({ isbetween: isbetween, colName: col, value: value, CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, CATEGORY3: Profile.division, CATEGORY4: Profile.subdivision, CATEGORY5: Profile.area, ROLES: userInfo?.ROLE, serach: Profile.account === '' && Profile.ga === '' && Profile.circle === '' && Profile.division === '' && Profile.subdivision === '' && Profile.area === '' ? false : true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } })
		if (data.success === true) {
			setTableDataInApi(data.data.data)
			
		setModalLoad(false)


		} else {
			console.log('somthing want wrong')
		setModalLoad(false)

		}
	}

	let colors = ['#008ffb', '#00e396', '#feb019', '#ff4560', '#775dcf', '#FF7700', '#554994', "#D36B00", "#0096FF"];
	
	const series1 = [
		{
			name: "Heartbeat Success",
			data: [letest24?.heart_success],
		},
		{
			name: "Heartbeat fail",
			data: [letest24?.heart_fail],
		},

		{
			name: "DailyData Success",
			data: [letest24?.daily_success],
		},
		{
			name: "DailyData Fail",
			data: [letest24?.daily_fail],
		},
		{
			name: "Hourly Success",
			data: [letest24?.load_success],
		},
		{
			name: "Hourly Fail",
			data: [letest24?.load_fail],
		},
		{
			name: "Alert",
			data: [letest24?.alert_count],
		},
		{
			name: "EVC Communication Fail",
			data: [letest24?.meter_comm_fail_count],
		},
		{
			name: "EVC/MC Meter Serial No. Not Match",
			data: [letest24?.NOT_METER_SRNO],
		}
	];
	const options1 = {
		chart: {
			id: "simple-bar",
			type: "bar",
			toolbar: {
				show: false,
			},
			events: {
				dataPointSelection: function (event, chartContext, config) {
					const DATA_point = GSMDATList[config.seriesIndex]
					console.log(DATA_point, config.seriesIndex);
					if(GSMDATList[config.seriesIndex]=='EVC_MC_METER_COMM_FAIL_LIST'||GSMDATList[config.seriesIndex]=='EVC_MC_METER_SR_NOT_MATCH_LIST'){
						GetConsumerIncolumeName(false, GSMDATAConsumerCheckList[config.seriesIndex], DATA_point, `${GSMDATAConsumerCheckList[config.seriesIndex]} between '${moment().add(-24, 'hours').utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss")}' and '${moment().utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss")}' AND (${GSMDATAConsumerCheckList[2]} not between '${moment().add(-24, 'hours').utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss")}' AND '${moment().utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss")}' OR (${GSMDATAConsumerCheckList[2]} IS NULL))`)
					}else{
					if (GSMDATList[config.seriesIndex] === 'HEARTBEAT_FAIL_LIST' || GSMDATList[config.seriesIndex] === 'INSTANTANEOUS_FAIL_LIST' || GSMDATList[config.seriesIndex] === 'DAILY_FAIL_LIST' || GSMDATList[config.seriesIndex] === 'HOURLY_FAIL_LIST' || GSMDATList[config.seriesIndex] === 'MONTH_BILL_FAIL_LIST') {
						GetConsumerIncolumeName(-1, GSMDATAConsumerCheckList[config.seriesIndex], DATA_point)
					} else {
						GetConsumerIncolumeName(true, GSMDATAConsumerCheckList[config.seriesIndex], DATA_point)
					}
				}
				}
			}
		},

		dataLabels: {
			enabled: true,
			// formatter: function (val) {
			//     return val + "%";
			// },
			offsetY: -20,
			style: {
				fontSize: "10px",
				fontWeight: 100,
				colors: ['rgb(154, 160, 172)'],
			},
		},
		grid: {
			padding: {
				top: 10,
				right: 20,
				bottom: 5,
				left: 40,
			},
		},

		plotOptions: {
			bar: {
				distributed: false,
				borderRadius: 3,
				columnWidth: '35%',
				dataLabels: {
					offsetY: -20,
					offsetX: 0,
					horizontal: true,
					style: {
						fontSize: "11px",
					},
					position: "top",
				},
			},
		},
		colors: ['rgb(0, 126, 51)','rgb(50,225,79)','rgb(51,33,113)','rgb(120,111,206)','rgb(255, 119, 0)','rgb(240, 193, 91)','rgb(120,111,206)','rgb(255, 69, 96)'],
		legend: {
			show: true,

			fontSize: "12px",
			fontWeight: 100,
			offsetY: 0,
			labels: {
				colors: 'rgb(154, 160, 172)',

			},
			itemMargin: {
				horizontal: 10,
				vertical: 3
			},
		},
		xaxis: {
			categories: [[moment().format('DD-MM-YYYY') ,moment().format('ddd'), '(Live)']],
			labels: {
				show: true,

				style: {
					colors: 'rgb(154, 160, 172)',
					fontSize: "12px",
					fontWeight: 200,
				},
			},
			title: {
				text: "Date",
				rotate: 0,
				offsetX: 0,
				offsetY: 100,
				style: {
					color: 'rgb(154, 160, 172)',
					fontSize: "12px",
					fontWeight: 200,
				},
			},
		},
		yaxis: {
			tickAmount: 7,
			labels: {
				show: true,

				style: {
					colors: 'rgb(154, 160, 172)',
					fontSize: "12px",
					fontWeight: 200,
				},
				offsetX: 20,
			},
			// title: {
			//     text: "Count",
			//     rotate: -90,
			//     offsetX: 0,
			//     offsetY: 0,
			//     style: {
			//         fontSize: '11px',
			//         fontWeight: 200,
			//     },
			// },
		},
	};

	const seriesMonth = [
		{
			name: "Monthly Success",
			data: AllGSMMonthChartData?.month_success,
		},
		{
			name: "Monthly Fail",
			data: AllGSMMonthChartData?.month_fail,
		}
	];
	const optionsMonth = {
		chart: {
			id: "simple-bar",
			type: "bar",
			toolbar: {
				show: false,
			},
			events: {
				dataPointSelection: function (event, chartContext, config) {
					const DATA_point = MonthList[config.seriesIndex]
					console.log(MonthList[config.seriesIndex], config.dataPointIndex, config.seriesIndex);
					if (config.dataPointIndex === 6) {
						if (DATA_point === 'MONTH_BILL_FAIL_LIST') {
							GetConsumerIncolumeName(false, 'EMT_TS_BILL', DATA_point, `MONTH(EMT_TS_BILL)!='${moment(DateMonthInLong[config.dataPointIndex], 'MMMM-YYYY').format('MM')}' AND YEAR(EMT_TS_BILL)='${moment(DateMonthInLong[config.dataPointIndex], 'MMMM-YYYY').format('YYYY')}' or EMT_TS_BILL is null`)
						} else {
							GetConsumerIncolumeName(false, 'EMT_TS_BILL', DATA_point, `MONTH(EMT_TS_BILL)='${moment(DateMonthInLong[config.dataPointIndex], 'MMMM-YYYY').format('MM')}' AND YEAR(EMT_TS_BILL)='${moment(DateMonthInLong[config.dataPointIndex], 'MMMM-YYYY').format('YYYY')}'`)
						}
					} else {
						onHandalGsmChart(MonthList[config.seriesIndex], AllGSMMonthChartData.SRNO[config.dataPointIndex], true)
					}
				}
			}
		},
		dataLabels: {
			enabled: true,
			// formatter: function (val) {
			//     return val + "%";
			// },
			offsetY: -20,
			style: {
				fontSize: "10px",
				fontWeight: 100,
				colors: ["#304758"],
			},
		},
		grid: {
			padding: {
				top: 10,
				right: 20,
				bottom: 5,
				left: 40,
			},
		},

		plotOptions: {
			bar: {
				distributed: false,
				borderRadius: 3,
				borderRadiusApplication: 'end',
				columnWidth: '35%',
				dataLabels: {
					offsetY: -20,
					offsetX: 0,
					horizontal: true,
					style: {
						fontSize: "11px",
					},
					position: "top",
				},
			},
		},
		colors: ["rgb(0, 126, 51)", "rgb(50,225,79)", "rgb(51, 181, 229)", "rgb(0, 153, 204)", "rgb(255, 187, 51)", "rgb(255, 119, 0)"],

		legend: {
			show: true,
			fontFamily: 'Helvetica, Arial',
			fontSize: "12px",
			labels: {
				colors: 'rgb(154, 160, 172)',

			},
			itemMargin: {
				horizontal: 10,
				vertical: 3
			},
			fontWeight: 100,
			offsetY: 0,
		},
		xaxis: {
			categories: DateMonthInLong,
			labels: {
				show: true,
				style: {
					colors: 'rgb(154, 160, 172)',
					fontSize: "12px",
					fontWeight: 200,
				},
			},
			title: {
				text: "Date",
				rotate: 0,
				offsetX: 0,
				offsetY: 100,
				style: {
					fontSize: "12px",
					fontWeight: 200,
					color: 'rgb(154, 160, 172)',
				},
			},
		},
		yaxis: {
			tickAmount: 7,
			labels: {
				show: true,
				style: {
					colors: 'rgb(154, 160, 172)',
					fontSize: "12px",
					fontWeight: 200,
				},
				offsetX: 20,
			},
			title: {
				text: "Count",
				rotate: -90,
				offsetX: 0,
				offsetY: 0,
				style: {
					color: 'rgb(154, 160, 172)',
					fontSize: "12px",
					fontWeight: 200,
				},
			},
		},
	};


	// const seriesEvent = [
	// 	{
	// 		name: "Volt Event",
	// 		data: AllGSMEventChartData?.volt,
	// 	},
	// 	{
	// 		name: "Current Event",
	// 		data: AllGSMEventChartData?.current,
	// 	},
	// 	{
	// 		name: "Power Event",
	// 		data: AllGSMEventChartData?.power,
	// 	},
	// 	{
	// 		name: "Other Event",
	// 		data: AllGSMEventChartData?.other,
	// 	},
	// 	{
	// 		name: "Transaction Event",
	// 		data: AllGSMEventChartData?.transection,
	// 	}, {
	// 		name: "Nonrollover Event",
	// 		data: AllGSMEventChartData?.nonrollover,
	// 	}, {
	// 		name: "Control Event",
	// 		data: AllGSMEventChartData?.control,
	// 	}
	// ];
	// const optionsEvent = {
	// 	chart: {
	// 		id: "simple-bar",
	// 		type: "bar",
	// 		toolbar: {
	// 			show: false,
	// 		},
	// 		events: {
	// 			dataPointSelection: function (event, chartContext, config) {
	// 				const DATA_point = GSMEventList[config.seriesIndex]
	// 				console.log(config.dataPointIndex);
	// 				if (config.dataPointIndex === 6) {
	// 					if (DATA_point === 'HEARTBEAT_FAIL_LIST' || DATA_point === 'INSTANTANEOUS_FAIL_LIST' || DATA_point === 'DAILY_LOAD_FAIL_LIST' || DATA_point === 'LOAD_SURVEY_FAIL_LIST' || DATA_point === 'MONTH_BILL_FAIL_LIST') {
	// 						GetConsumerIncolumeName(false, GSMEventConsumerCheckList[config.seriesIndex], DATA_point, `DATE(${GSMEventConsumerCheckList[config.seriesIndex]})!='${moment(DateEventInLong[config.dataPointIndex], 'DD-MM-YYYY').format('YYYY-MM-DD')}'`)
	// 					} else {
	// 						GetConsumerIncolumeName(false, GSMEventConsumerCheckList[config.seriesIndex], DATA_point, `DATE(${GSMEventConsumerCheckList[config.seriesIndex]})='${moment(DateEventInLong[config.dataPointIndex], 'DD-MM-YYYY').format('YYYY-MM-DD')}'`)
	// 					}
	// 				} else {
	// 					onHandalGsmChart(DATA_point, AllGSMEventChartData.SRNO[config.dataPointIndex], false)
	// 				}
	// 			}
	// 		}
	// 	},

	// 	dataLabels: {
	// 		enabled: true,
	// 		// formatter: function (val) {
	// 		//     return val + "%";
	// 		// },
	// 		offsetY: -20,
	// 		style: {
	// 			fontSize: "10px",
	// 			fontWeight: 100,
	// 			colors: ["#304758"],
	// 		},
	// 	},
	// 	grid: {
	// 		padding: {
	// 			top: 10,
	// 			right: 20,
	// 			bottom: 5,
	// 			left: 40,
	// 		},
	// 	},

	// 	plotOptions: {
	// 		bar: {
	// 			columnWidth: '50%',
	// 			distributed: false,
	// 			borderRadius: 3,
	// 			dataLabels: {
	// 				offsetY: -20,
	// 				offsetX: 0,
	// 				horizontal: true,
	// 				style: {
	// 					fontSize: "11px",
	// 				},
	// 				position: "top",
	// 			},
	// 		},
	// 	},
	// 	colors: ["rgb(0, 200, 81)", "rgb(0, 126, 51)", "rgb(51, 181, 229)", "rgb(0, 153, 204)", "rgb(255, 187, 51)", "rgb(255, 119, 0)"],

	// 	legend: {
	// 		show: true,
	// 		fontFamily: 'Helvetica, Arial',
	// 		fontSize: "12px",
	// 		labels: {
	// 			colors: 'rgb(154, 160, 172)',

	// 		},
	// 		itemMargin: {
	// 			horizontal: 10,
	// 			vertical: 3
	// 		},
	// 		fontWeight: 100,
	// 		offsetY: 0,
	// 	},
	// 	xaxis: {
	// 		categories: DateEventInLong,
	// 		labels: {
	// 			show: true,
	// 			style: {
	// 				colors: 'rgb(154, 160, 172)',
	// 				fontSize: "12px",
	// 				fontWeight: 200,
	// 			},
	// 		},
	// 		title: {
	// 			text: "Date",
	// 			rotate: 0,
	// 			offsetX: 0,
	// 			offsetY: 0,
	// 			style: {
	// 				fontSize: "12px",
	// 				fontWeight: 200,
	// 				color: 'rgb(154, 160, 172)',
	// 			},
	// 		},
	// 	},
	// 	yaxis: {
	// 		tickAmount: 7,
	// 		labels: {
	// 			show: true,
	// 			style: {
	// 				colors: 'rgb(154, 160, 172)',
	// 				fontSize: "12px",
	// 				fontWeight: 200,
	// 			},
	// 			offsetX: 20,
	// 		},
	// 		title: {
	// 			text: "Count",
	// 			rotate: -90,
	// 			offsetX: 0,
	// 			offsetY: 0,
	// 			style: {
	// 				color: 'rgb(154, 160, 172)',
	// 				fontSize: "12px",
	// 				fontWeight: 200,
	// 			},
	// 		},
	// 	},
	// };

	const onChartItemClick = (id, name, color) => {

		setColorText(color)
		setIsModalVisible(true)
		setModelId(`${name}`)
		onMeterDataModalShow(ModemId[id], 'MODEM_TYPE')
	}


	const onMeterTableClick = (id, name, color) => {
		setIsModalVisible(true)
		setModelId(`${name}`)
		setColorText(color)

		onMeterDataModalShow(MeterId[id], 'EVC_MC_METER_TYPE')
	}

	const onMechanicalMeterTableClick = (id, name, color) => {
		setIsModalVisible(true)
		setModelId(`${name}`)
		setColorText(color)

		onMeterDataModalShow(MechancalMeterId[id], 'MECHANICAL_TYPE')
	}

	const onServiceClick = (id, name, color) => {
		setIsModalVisible(true)
		setModelId(`${name}`)
		setColorText(color)
		if(!serviceProvid.castegory[id].split('(')[0]){
			GetConsumerIncolumeName(false, '', serviceProvid.category[id].split('(')[0], `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.SIM_NWKP') IS null OR JSON_VALUE(HEARTBEAT_LAST_DATA,'$.SIM_NWKP')='' OR HEARTBEAT_LAST_DATA IS NULL`)

		}else{
		onMeterDataModalShow(serviceProvid.category[id].split('(')[0], "JSON_VALUE(HEARTBEAT_LAST_DATA,'$.SIM_NWKP')")
		}
	}

	const onFrimwarTableClick = (id, name, color) => {
		setIsModalVisible(true)
		setModelId(`${name}`)
		setColorText(color)
		onMeterDataModalShow(name, "JSON_VALUE(HEARTBEAT_LAST_DATA,'$.VERSTR')")
	}

	const onMeterDataModalShow = async (id, colName) => {
		console.log(Profile);
		setModalLoad(true)

		const data = await onGetGSMSmartMeterConsumerDetailsByColumn({ colName: colName, value: id, CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, CATEGORY3: Profile.division, CATEGORY4: Profile.subdivision, CATEGORY5: Profile.area, ROLES: userInfo?.ROLE, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } })
		if (data.success === true) {
			setTableDataInApi(data.data.data)
		setModalLoad(false)

		} else {
		setModalLoad(false)

			console.log('something want wrong')
		}
	}

	const onHandalRssiInConsummer = async (name, color, colName, start, end) => {
		setModalLoad(true)
		setIsModalVisible(true)

		setModelId(`${name}`)
		setColorText(color)
		const data = await onGetConsumerDetailsByColumnBetween({ colName: colName, start: start, end: end, CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, CATEGORY3: Profile.division, CATEGORY4: Profile.subdivision, CATEGORY5: Profile.area, ROLES: userInfo?.ROLE, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } })
		if (data.success === true) {
			setTableDataInApi(data.data.data)
		setModalLoad(false)

		} else {
			console.log('something want wrong')
			setModalLoad(false)

		}
	}
	var options2 = {
		chart: {
			//  width: "80%",
			height: 350,
			// offsetY: -20,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;
					if(!categoryModem[date_index]){
						GetConsumerIncolumeName(false, '', categoryModem[date_index], `MODEM_TYPE IS null OR MODEM_TYPE=''`)

					}else{
					onChartItemClick(date_index, categoryModem[date_index], chartContext.w.globals.colors[date_index])
					}
					//var bar_index = config.seriesIndex;
					// alert(categoryModem[date_index] + " - " + seriesModem[date_index]);

				},
				dataPointMouseEnter: function (event) {
					event.path[0].style.cursor = "pointer";
				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150

		},

		labels: categoryModem,
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return seriesModem[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}

			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: colors
	};

	var options4 = {
		chart: {
			//  width: "80%",
			height: 350,
			// offsetY: -20,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;
					console.log(seriesFirmwar);
					//var bar_index = config.seriesIndex;
					if(!categoryFirmwar[date_index].split('(')[0]){
						GetConsumerIncolumeName(false, '', categoryFirmwar[date_index].split('(')[0], `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.VERSTR') IS null OR JSON_VALUE(HEARTBEAT_LAST_DATA,'$.VERSTR')='' OR HEARTBEAT_LAST_DATA IS NULL`)
			
					}else{
					onFrimwarTableClick(date_index, categoryFirmwar[date_index].split('(')[0], chartContext.w.globals.colors[date_index].split('(')[0])
					}
					// alert(categoryFirmwar[date_index] + " - " + seriesFirmwar[date_index]);
				},
				dataPointMouseEnter: function (event) {
					event.path[0].style.cursor = "pointer";
				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150

		},

		labels: categoryFirmwar,
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return seriesFirmwar[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}

			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: colors

	};

	var options14 = {
		chart: {
			//    width: "80%",
			height: 350,
			// offsetY: -20,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;
					// 	//var bar_index = config.seriesIndex;
					console.log(chartContext.w.globals.colors, config.seriesIndex, config.dataPointIndex);
					if (config.dataPointIndex == 0) {
						onHandalRssiInConsummer(serisBAT[date_index], chartContext.w.globals.colors[date_index], "JSON_VALUE(HEARTBEAT_LAST_DATA,'$.BAT_PER')", 0, 20)
					} else if (config.dataPointIndex == 1) {
						onHandalRssiInConsummer(serisBAT[date_index], chartContext.w.globals.colors[date_index], "JSON_VALUE(HEARTBEAT_LAST_DATA,'$.BAT_PER')", 21, 40)
					} else if (config.dataPointIndex == 2) {
						onHandalRssiInConsummer(serisBAT[date_index], chartContext.w.globals.colors[date_index], "JSON_VALUE(HEARTBEAT_LAST_DATA,'$.BAT_PER')", 41, 60)
					} else if (config.dataPointIndex == 3) {
						onHandalRssiInConsummer(serisBAT[date_index], chartContext.w.globals.colors[date_index], "JSON_VALUE(HEARTBEAT_LAST_DATA,'$.BAT_PER')", 61, 80)
					} else if (config.dataPointIndex == 4) {
						onHandalRssiInConsummer(serisBAT[date_index], chartContext.w.globals.colors[date_index], "JSON_VALUE(HEARTBEAT_LAST_DATA,'$.BAT_PER')", 81, 100)
					}

				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150
		},

		labels: serisBAT.map((item, id) => (item + `(${categoryBAT[id]})`)),
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return categoryBAT[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}
			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: colors

	};


	var options3 = {
		chart: {
			//    width: "80%",
			height: 350,
			// offsetY: -20,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;
					//var bar_index = config.seriesIndex;
					// console.log(chartContext.w.globals.colors,config.seriesIndex,config.dataPointIndex);
					if(!categoryMeter[date_index]){
						GetConsumerIncolumeName(false, '', categoryMeter[date_index], `EVC_MC_METER_TYPE IS null OR EVC_MC_METER_TYPE=''`)

					}else{
					onMeterTableClick(date_index, categoryMeter[date_index], chartContext.w.globals.colors[date_index])
					}
					// alert(categoryMeter[date_index] + " - " + seriesMeter[date_index]);
				},
				dataPointMouseEnter: function (event) {
					event.path[0].style.cursor = "pointer";
				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150
		},

		labels: categoryMeter,
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return seriesMeter[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}
			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: colors

	};

	var options15 = {
		chart: {
			//    width: "80%",
			height: 350,
			// offsetY: -20,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;
					//var bar_index = config.seriesIndex;
					// console.log(chartContext.w.globals.colors,config.seriesIndex,config.dataPointIndex);
					onMechanicalMeterTableClick(date_index, categoryMechanicalMeter[date_index], chartContext.w.globals.colors[date_index])
					// alert(categoryMeter[date_index] + " - " + seriesMeter[date_index]);
				},
				dataPointMouseEnter: function (event) {
					event.path[0].style.cursor = "pointer";
				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150
		},

		labels: categoryMechanicalMeter,
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return seriesMechanicalMeter[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}
			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: colors

	};

	var options6 = {
		chart: {
			//    width: "80%",
			height: 350,
			// offsetY: -20,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;
					// 	//var bar_index = config.seriesIndex;
					console.log(chartContext.w.globals.colors, config.seriesIndex, config.dataPointIndex);
					if (config.dataPointIndex == 0) {
						onHandalRssiInConsummer(seriesRSSI[date_index], chartContext.w.globals.colors[date_index], "JSON_VALUE(HEARTBEAT_LAST_DATA,'$.GSM_RSSI')", 2, 9)
					} else if (config.dataPointIndex == 1) {
						onHandalRssiInConsummer(seriesRSSI[date_index], chartContext.w.globals.colors[date_index], "JSON_VALUE(HEARTBEAT_LAST_DATA,'$.GSM_RSSI')", 10, 14)
					} else if (config.dataPointIndex == 2) {
						onHandalRssiInConsummer(seriesRSSI[date_index], chartContext.w.globals.colors[date_index], "JSON_VALUE(HEARTBEAT_LAST_DATA,'$.GSM_RSSI')", 15, 19)
					} else if (config.dataPointIndex == 3) {
						onHandalRssiInConsummer(seriesRSSI[date_index], chartContext.w.globals.colors[date_index], "JSON_VALUE(HEARTBEAT_LAST_DATA,'$.GSM_RSSI')", 20, 31)
					}

				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150
		},

		labels: seriesRSSI,
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return categoryRSSI[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}
			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: colors

	};
	var options7 = {
		chart: {
			height: 350,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;
					// 	//var bar_index = config.seriesIndex;
					console.log(chartContext.w.globals.colors, config.seriesIndex, config.dataPointIndex);
					if (serviceProvid.category[config.dataPointIndex].split('(')[0] === 'VI') {
						GetConsumerIncolumeName(false, '', serviceProvid.category[config.dataPointIndex].split('(')[0], `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.SIM_NWKP')='IDEA' || JSON_VALUE(HEARTBEAT_LAST_DATA,'$.SIM_NWKP')='Vodafone IN' ||JSON_VALUE(HEARTBEAT_LAST_DATA,'$.SIM_NWKP')='Vi India'`)
					} else {
						onServiceClick(config.dataPointIndex, serviceProvid.category[config.dataPointIndex].split('(')[0], chartContext.w.globals.colors[date_index])
					}
				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150,
			markers: {
				width: 0,
				height: 0,
				strokeWidth: 0,
				strokeColor: '#fff',
				fillColors: undefined,
				radius: 0,
				onClick: undefined,
				offsetX: -12,
				offsetY: 0,
				customHTML: function () {
					return '<span class="custom-marker"><i class="fa-solid fa-sim-card"></i></span>'
				}
			},

		},

		labels: serviceProvid.category,
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return serviceProvid.series[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150,
					markers: {
						width: 0,
						height: 0,
						strokeWidth: 0,
						strokeColor: '#fff',
						fillColors: undefined,
						radius: 0,
						onClick: undefined,
						offsetX: -12,
						offsetY: 0,
						customHTML: function () {
							return '<span class="custom-marker"><i class="fa-solid fa-sim-card"></i></span>'
						}
					},
				}
			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100,
					markers: {
						width: 0,
						height: 0,
						strokeWidth: 0,
						strokeColor: '#fff',
						fillColors: undefined,
						radius: 0,
						onClick: undefined,
						offsetX: -12,
						offsetY: 0,
						customHTML: function () {
							return '<span class="custom-marker"><i class="fa-solid fa-sim-card"></i></span>'
						}
					},
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100,
					markers: {
						width: 0,
						height: 0,
						strokeWidth: 0,
						strokeColor: '#fff',
						fillColors: undefined,
						radius: 0,
						onClick: undefined,
						offsetX: -12,
						offsetY: 0,
						customHTML: function () {
							return '<span class="custom-marker"><i class="fa-solid fa-sim-card"></i></span>'
						}
					},
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100,
					markers: {
						width: 0,
						height: 0,
						strokeWidth: 0,
						strokeColor: '#fff',
						fillColors: undefined,
						radius: 0,
						onClick: undefined,
						offsetX: -12,
						offsetY: 0,
						customHTML: function () {
							return '<span class="custom-marker"><i class="fa-solid fa-sim-card"></i></span>'
						}
					},
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: colors

	};

	var options8 = {
		chart: {
			//  width: "80%",
			height: 350,
			// offsetY: -20,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;

					GetConsumerIncolumeName(false, '', tagsCount.category[date_index].split('(')[0], `TAGS LIKE '%${tagsCount.id[date_index]}%'`)
					//var bar_index = config.seriesIndex;
					// alert(categoryModem[date_index] + " - " + seriesModem[date_index]);

				},
				dataPointMouseEnter: function (event) {
					event.path[0].style.cursor = "pointer";
				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150

		},

		labels: tagsCount.category,
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return tagsCount.series[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}

			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: colors
	};
	var options9 = {
		chart: {
			//  width: "80%",
			height: 350,
			// offsetY: -20,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;

					GetConsumerIncolumeName(false, '', MCOMST.category[date_index].split('(')[0], `MCOMST=${MCOMST.code[date_index]}`)
				},
				dataPointMouseEnter: function (event) {
					event.path[0].style.cursor = "pointer";
				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150

		},

		labels: MCOMST.category,
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return MCOMST.series[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}

			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: colors
	};
	var options10 = {
		chart: {
			//  width: "80%",
			height: 350,
			// offsetY: -20,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;
					GetConsumerIncolumeName(false, '', DEVICE_STATUS.categories[date_index].split('(')[0], `MMD_STATUS_ONLINE_OFFLINE='${DEVICE_STATUS.categories[date_index].split('(')[0]}'`)
					//var bar_index = config.seriesIndex;
					// alert(categoryModem[date_index] + " - " + seriesModem[date_index]);

				},
				dataPointMouseEnter: function (event) {
					event.path[0].style.cursor = "pointer";
				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150

		},

		labels: DEVICE_STATUS.categories,
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return DEVICE_STATUS.series[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}

			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: [DEVICE_STATUS?.categories[0]?.split('(')[0] === 'online' ? '#54ca68' : '#fc544b', DEVICE_STATUS?.categories[1]?.split('(')[0] === 'offline' ? '#fc544b' : '#54ca68']
	};
	var options11 = {
		chart: {
			//  width: "80%",
			height: 350,
			// offsetY: -20,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;
					if(!GSM_BAND.categories[date_index].split('(')[0]){
						GetConsumerIncolumeName(false, '', GSM_BAND.categories[date_index].split('(')[0], `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.GSM_BAND') IS null OR JSON_VALUE(HEARTBEAT_LAST_DATA,'$.GSM_BAND')='' OR HEARTBEAT_LAST_DATA IS NULL`)
			
					}else{
					GetConsumerIncolumeName(false, '', GSM_BAND.categories[date_index].split('(')[0], `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.GSM_BAND')='${GSM_BAND.categories[date_index].split('(')[0]}'`)
					}
					//var bar_index = config.seriesIndex;
					// alert(categoryModem[date_index] + " - " + seriesModem[date_index]);

				},
				dataPointMouseEnter: function (event) {
					event.path[0].style.cursor = "pointer";
				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150

		},

		labels: GSM_BAND.categories,
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return GSM_BAND.series[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}

			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: colors
	};
	var options13 = {
		chart: {
			//  width: "80%",
			height: 350,
			// offsetY: -20,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;
					if (APM.category[date_index].split('(')[0] == 'Not Available') {
						GetConsumerIncolumeName(false, '', APM.category[date_index].split('(')[0], `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.APN')=''`)
					}else if (APM.category[date_index].split('(')[0] == 'null') {
						GetConsumerIncolumeName(false, '', APM.category[date_index].split('(')[0], `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.APN') IS NULL`)
					} else {
						GetConsumerIncolumeName(false, '', APM.category[date_index].split('(')[0], `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.APN')='${APM.category[date_index].split('(')[0]}'`)
					}
					//var bar_index = config.seriesIndex;
					// alert(categoryModem[date_index] + " - " + seriesModem[date_index]);

				},
				dataPointMouseEnter: function (event) {
					event.path[0].style.cursor = "pointer";
				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150

		},

		labels: APM.category,
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return APM.series[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}

			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: colors
	};

	var option16 = {
		chart: {
			//    width: "80%",
			height: 350,
			// offsetY: -20,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;
					if(date_index==0){
						GetConsumerIncolumeName('NO', '', BlankData[date_index], `CUSTOMER_STATUS=1 AND CONSUMER_SUB_STATUS=1`)
					}else if(date_index==1){
						GetConsumerIncolumeName('NO', '', BlankData[date_index], `CUSTOMER_STATUS=0 AND CONSUMER_SUB_STATUS=2`)
					}else if(date_index==2){
						GetConsumerIncolumeName('NO', '', BlankData[date_index], `CUSTOMER_STATUS=0`)
					}else if(date_index==3){
						GetConsumerIncolumeName('NO', '', BlankData[date_index], `CUSTOMER_STATUS=-1`)
					}else if(date_index==4){
						GetConsumerIncolumeName('NO', '', BlankData[date_index], `CUSTOMER_STATUS=2`)
					}
				},
				dataPointMouseEnter: function (event) {
					event.path[0].style.cursor = "pointer";
				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150
		},

		labels: BlankData&&BlankData.map((item,id)=>(item+`(${tableData[id]})`)),
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return tableData[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}
			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: ['#00e396','#00e396','#ff4560','#feb019','#008ffb']

	};

	var options16 = {
		chart: {
			//  width: "80%",
			height: 350,
			// offsetY: -20,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;
					if(date_index==0){
						
					GetConsumerIncolumeName(false, '', UnlockBrand.categories[date_index], `(JSON_VALUE(UNLOCK_CONFIG,'$.UNLOCK_STATUS')=0 OR UNLOCK_CONFIG IS NULL) AND EVC_MC_METER_TYPE='METUID1665810585135'`)
					}else{
						GetConsumerIncolumeName(false, '', UnlockBrand.categories[date_index], `JSON_VALUE(UNLOCK_CONFIG,'$.UNLOCK_STATUS')=1 AND EVC_MC_METER_TYPE='METUID1665810585135'`)
					}
					//var bar_index = config.seriesIndex;
					// alert(categoryModem[date_index] + " - " + seriesModem[date_index]);

				},
				dataPointMouseEnter: function (event) {
					event.path[0].style.cursor = "pointer";
				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150

		},

		labels: UnlockBrand.categories,
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return UnlockBrand.series[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}

			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: ['rgb(0, 227, 150)','rgb(255, 69, 96)']
	};
	const handleCancel = () => {
		setIsModalVisible(false);
		settabShow(false)
		setTimeout(() => {
			setTableDataInApi([])
		}, 100)
	};
	const onHandaleViewGSM = (id) => {
		window.open(`/view_existing_consumer_gsm/${id}`, '_blank')
	}

	


	const ongetGaById = async (id) => {
		const data1 = await getGaById(id);
		if (data1.success === true) {
			setGaData(data1.data.data);
		}
	};

	const ongetCircle = async (id) => {
		const data1 = await getCircleById(id);
		if (data1.success === true) {
			setCircleData(data1.data.data);
		}
	};
	const ongetSubdevisionById = async (id) => {
		const data1 = await getSubdevisionById(id);
		if (data1.success === true) {
			setSubdevisionData(data1.data.data);
		}
	};
	const ongetDivisionById = async (id) => {
		const data3 = await getDivisionById(id);
		if (data3.success === true) {
			setDivisionData(data3.data.data);
		}
	};
	const ongetArea = async (id) => {
		const data3 = await getAreaById(id);
		if (data3.success === true) {
			setAreaData(data3.data.data);
		}
	};
	const [NameObj, setNameObj] = useState({})
	const ongetProfilNameByAccountId = async (id) => {
		const data = await getProfilNameByAccountId({ ID: id })
		if (data.success === true) {
			setNameObj(JSON.parse(data?.data?.data[0]?.PROFILE_NAME || '{}'))
		} else {
			console.log('something want wrong')
		}
	}

	const onProfileWiseSearchClick = () => {
		onChangesProfileWiseSerch({ CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, CATEGORY3: Profile.division, CATEGORY4: Profile.subdivision, CATEGORY5: Profile.area, ROLES: userInfo?.ROLE, serach: true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } });
	}

	useEffect(() => {
		if (Profile.account !== "") {
			ongetGaById(Profile.account);
			setProfile({ ...Profile, ga: "", circle: "", division: "", subdivision: "", area: "" });
			setCircleData([]);
			setSubdevisionData([]);
			setDivisionData([]);
			setAreaData([])

			ongetProfilNameByAccountId(Profile.account)

		} else {
			setProfile({ ...Profile, ga: "", circle: "", division: "", subdivision: "", area: "" });
			setGaData([]);
			setCircleData([]);
			setSubdevisionData([]);
			setDivisionData([]);
			setAreaData([]);
			if (Object.keys(permision).length > 0) {
				// onChangesProfileWiseSerch({ CATEGORY0: '', CATEGORY1: '', CATEGORY2: '', CATEGORY3: '', CATEGORY4: '', CATEGORY5: '', ROLES: userInfo?.ROLE, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } });
			}
			setNameObj({})
		}
	}, [Profile.account]);

	useEffect(() => {
		if (Profile.ga !== "") {
			ongetCircle(Profile.ga);
			setProfile({ ...Profile, circle: "", division: "", subdivision: "", area: "" });
			setSubdevisionData([]);
			setDivisionData([]);
			setAreaData([]);
			// onChangesProfileWiseSerch({ CATEGORY0: Profile.account, CATEGORY1: Profile.ga, ROLES: userInfo?.ROLE, serach: true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } });
		} else {
			setProfile({ ...Profile, circle: "", division: "", subdivision: "", area: "" });
			setCircleData([]);
			setDivisionData([]);
			setSubdevisionData([]);
			setAreaData([]);
			if (Object.keys(permision).length > 0) {
				// onChangesProfileWiseSerch({ CATEGORY0: Profile.account, ROLES: userInfo?.ROLE, serach: true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } });
			}

		}
	}, [Profile.ga]);

	useEffect(() => {
		if (Profile.circle !== "") {
			ongetDivisionById(Profile.circle);
			setProfile({ ...Profile, division: "", subdivision: "", area: "" });
			setAreaData([]);
			setSubdevisionData([]);
			// onChangesProfileWiseSerch({ CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, ROLES: userInfo?.ROLE, serach: true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } });

		} else {
			setProfile({ ...Profile, division: "", subdivision: "", area: "" });
			setAreaData([]);
			setDivisionData([]);
			setSubdevisionData([]);
			if (Object.keys(permision).length > 0) {
				// onChangesProfileWiseSerch({ CATEGORY0: Profile.account, CATEGORY1: Profile.ga, ROLES: userInfo?.ROLE, serach: true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } });
			}

		}
	}, [Profile.circle]);

	useEffect(() => {
		if (Profile.division !== "") {
			ongetSubdevisionById(Profile.division);
			setAreaData([]);
			setProfile({ ...Profile, subdivision: "", area: "" });
			// onChangesProfileWiseSerch({ CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, CATEGORY3: Profile.division, ROLES: userInfo?.ROLE, serach: true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } });
		} else {
			setProfile({ ...Profile, subdivision: "", area: "" });
			setSubdevisionData([]);
			setAreaData([]);
			if (Object.keys(permision).length > 0) {
				// onChangesProfileWiseSerch({ CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, ROLES: userInfo?.ROLE, serach: true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } });
			}
		}
	}, [Profile.division]);

	useEffect(() => {
		if (Profile.subdivision !== "") {
			ongetArea(Profile.subdivision);
			setProfile({ ...Profile, area: "" });
			// onChangesProfileWiseSerch({ CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, CATEGORY3: Profile.division, CATEGORY4: Profile.subdivision, ROLES: userInfo?.ROLE, serach: true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } });
		} else {
			setProfile({ ...Profile, area: "" });
			setAreaData([]);
			if (Object.keys(permision).length > 0) {
				// onChangesProfileWiseSerch({ CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, CATEGORY3: Profile.division, ROLES: userInfo?.ROLE, serach: true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } });
			}
		}
	}, [Profile.subdivision]);

	useEffect(() => {
		if (Profile.area !== "") {
			// onChangesProfileWiseSerch({ CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, CATEGORY3: Profile.division, CATEGORY4: Profile.subdivision, CATEGORY5: Profile.area, ROLES: userInfo?.ROLE, serach: true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } });
		} else {
			if (Object.keys(permision).length > 0) {
				// onChangesProfileWiseSerch({ CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, CATEGORY3: Profile.division, ROLES: userInfo?.ROLE, serach: true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } });
			}
		}
	}, [Profile.area]);

	function getSecondsTodayBydate(ts) {
		var now = moment().add(-moment().utcOffset(), "m").format("DD/MM/YYYY HH:mm:ss");
		var then = moment.utc(ts).add(-moment().utcOffset(), "m").format("DD/MM/YYYY HH:mm:ss");
		return moment(now, "DD/MM/YYYY HH:mm:ss").diff(moment(then, "DD/MM/YYYY HH:mm:ss"), 'second')
	}

	// const labelsForChartJS = dateInLong
	// colors: ["rgb(0, 200, 81)", "rgb(0, 126, 51)", "rgb(51, 181, 229)", "rgb(0, 153, 204)", "rgb(255, 187, 51)", "rgb(255, 119, 0)"],
	const InstallChartJs = {
		labels: installData && installData.map((item) => ([moment(item?.dates).format('DD-MM-YYYY'),moment(item?.dates).format('ddd')])),
		datasets: [
			{
				label: "Installation",
				data: installData && installData.map((item) => (item.total)),
				backgroundColor: 'rgb(0, 200, 81)',
				maxBarThickness: 30,
			}
		]
	}
	const InstallOptionChartJS = {
		responsive: true,
		maintainAspectRatio: false,
		scales: {
			x: {
				ticks: {
					font: function (context) {
						var w = context.chart.width;
						return {
							size: w < 512 ? 8 : 10,
						};
					},
				}
			}
		},
		animation: {
			duration: 0
		},

		plugins: {
			legend: {
				position: 'bottom',
				labels: {
					pointStyleWidth: 10,
					usePointStyle: true,
					pointStyle: 'rectRounded'
				}
			},
			zoom: {
				zoom: {
					wheel: {
						enabled: true // SET SCROOL ZOOM TO TRUE
					},
					mode: "x",
				},
				pan: {
					enabled: true,
					mode: "x",
				}
			},
			datalabels: {
				align: 'end',
				anchor: 'end',
				clamp: true,
				color: "black",
				padding: {
					top: 0,
					bottom: 0
				},
				font: function (context) {
					var w = context.chart.width;
					return {
						size: w < 512 ? 10 : 12,

					};
				},
			}
		},
		layout: {
			padding: {
				left: 50,
				right: 50,
				top: 20
			}
		},
		// onClick: (event) => {
		// 	console.log(getElementAtEvent(chartRef.current, event));
		// 	console.log("first")
		// 	// getElementsAtEvent(elements)
		// 	// const chart = chartRef.current;
		// 	// const element = chart.getElementAtEvent(event)[0];
		// 	// const dataset = chart.data.datasets[element._datasetIndex];
		// 	// const xLabel = chart.data.labels[element._index];
		// 	// const value = dataset.data[element._index];
		// 	// console.log(dataset.label + " at " + xLabel + ": " + value);
		// },
	};
	const dataForChartJs = {
		labels: dateInLong.map((item)=>([item+` (${moment(item,'DD-MM-YYYY').format('ddd')})`])),
		datasets: [
			{
				label: "Heartbeat Success",
				data: AllGSMChartData?.heartbeat_success,
				barPercentage: 1.0,
				backgroundColor: 'rgb(0, 126, 51)',
				borderRadius: 5,
			},
			{
				label: "Heartbeat fail",
				data: AllGSMChartData?.heartbeat_fail,
				barPercentage: 1.0,
				backgroundColor: 'rgb(50,225,79)',
				borderRadius: 5,
			},

			{
				label: "DailyData Success",
				data: AllGSMChartData?.daily_success,
				barPercentage: 1.0,
				backgroundColor: 'rgb(51,33,113)',
				borderRadius: 5,
			},
			{
				label: "DailyData Fail",
				data: AllGSMChartData?.daily_fail,
				barPercentage: 1.0,
				backgroundColor: 'rgb(120,111,206)',
				borderRadius: 5,
			},
			{
				label: "Hourly Success",
				data: AllGSMChartData?.load_success,
				barPercentage: 1.0,
				backgroundColor: 'rgb(255, 119, 0)',
				borderRadius: 5,
			},
			{
				label: "Hourly Fail",
				data: AllGSMChartData?.load_fail,
				barPercentage: 1.0,
				backgroundColor: 'rgb(240, 193, 91)',
				borderRadius: 5,
			},
			{
				label: "Alert",
				data: AllGSMChartData?.alert_count,
				barPercentage: 1.0,
				backgroundColor: 'rgb(120,111,206)',
				borderRadius: 5,
			},
			{
				label: "EVC communication Fail",
				data: AllGSMChartData?.meter_comm_fail_count,
				barPercentage: 1.0,
				backgroundColor: 'rgb(255, 69, 96)',
				borderRadius: 5,
			},
			{
				label: "EVC/MC Meter Serial No. Not Match",
				data: AllGSMChartData?.NOT_METER_SRNO,
				barPercentage: 1.0,
				backgroundColor: 'rgb(59 130 246)',
				borderRadius: 5,
			}
		],
	};
	let delayed;
	const optionsForChartJS = {
		responsive: true,
		maintainAspectRatio: false,
		scales: {
			x: {

				ticks: {
					maxRotation: 90,

				}
			}
		},
		animation: false,
		// animation: {
		// 	duration: 1000,
		// 	easing: 'easeInBounce',
		// 	onComplete: () => {
		// 		delayed = true;
		// 	},
		// 	delay: (context) => {
		// 		let delay = 0;
		// 		if (context.type === 'data' && context.mode === 'default' && !delayed) {
		// 			delay = context.dataIndex * 300 + context.datasetIndex * 100;
		// 		}
		// 		return delay;
		// 	},
		// },

		plugins: {
			legend: {
				position: 'bottom',
				fullSize: false,
				labels: {
					pointStyleWidth: 10,
					usePointStyle: true,
					pointStyle: 'rectRounded',
					
					font: function (context) {
						var w = context.chart.width;
						return {
							size: w < 512 ? 8 : 11,

						};
					},
				}
			},
			zoom: {
				zoom: {
					wheel: {
						enabled: true,
						modifierKey: 'ctrl' // SET SCROOL ZOOM TO TRUE
					},
					mode: "x",
				},
				pan: {
					enabled: true,
					mode: "x",
				}
			},
			datalabels: {
				align: 'end',
				anchor: 'end',
				clamp: true,
				color: "black",
				padding: {
					top: 0,
					bottom: 0
				},
				font: function (context) {
					var w = context.chart.width;
					return {
						size: w < 512 ? 10 : 12,

					};
				},

			}
		},
		layout: {
			padding: {
				left: 50,
				right: 50,
				top: 20,
			}
		},
	};
	var options12 = {
		chart: {
			//  width: "80%",
			height: 350,
			// offsetY: -20,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;
					console.log(IPV.categories[date_index]);
					GetConsumerIncolumeName(false, '', IPV.categories[date_index], `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.IPV4V6')=${IPV.categories[date_index].split('(')[0] == 'IPV4' ? '1' : IPV.categories[date_index].split('(')[0] == 'IPV6' ? '2' : '3'}`)
					//var bar_index = config.seriesIndex;
					// alert(categoryModem[date_index] + " - " + seriesModem[date_index]);

				},
				dataPointMouseEnter: function (event) {
					event.path[0].style.cursor = "pointer";
				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150

		},

		labels: IPV.categories,
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return IPV.IPV[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}

			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: colors
	};

	const onClick = (event) => {
		// console.log(getElementsAtEvent(chartRef.current, event));
		const { datasetIndex, index } = getElementAtEvent(chartRef.current, event)[0] || {};
		// console.log(datasetIndex, index)
		// console.log((getElementAtEvent(chartRef.current, event)[0]));
		const DATA_point = GSMDATList[datasetIndex]
		if (DATA_point) {
			if (index === 6) {
				if(GSMDATList[datasetIndex]=='EVC_MC_METER_COMM_FAIL_LIST'||GSMDATList[datasetIndex]=='EVC_MC_METER_SR_NOT_MATCH_LIST'){
					GetConsumerIncolumeName(false, GSMDATAConsumerCheckList[datasetIndex], DATA_point, `DATE(${GSMDATAConsumerCheckList[datasetIndex]})='${moment(dateInLong[index], 'DD-MM-YYYY').format('YYYY-MM-DD')}' AND (DATE(${GSMDATAConsumerCheckList[2]})!='${moment(dateInLong[index], 'DD-MM-YYYY').format('YYYY-MM-DD')}' OR ${GSMDATAConsumerCheckList[2]} IS NULL)`)
				}else{
				if (GSMDATList[datasetIndex] === 'HEARTBEAT_FAIL_LIST' || GSMDATList[datasetIndex] === 'INSTANTANEOUS_FAIL_LIST' || GSMDATList[datasetIndex] === 'DAILY_FAIL_LIST' || GSMDATList[datasetIndex] === 'HOURLY_FAIL_LIST' || GSMDATList[datasetIndex] === 'MONTH_BILL_FAIL_LIST') {
					GetConsumerIncolumeName(false, GSMDATAConsumerCheckList[datasetIndex], DATA_point, `DATE(${GSMDATAConsumerCheckList[datasetIndex]})!='${moment(dateInLong[index], 'DD-MM-YYYY').format('YYYY-MM-DD')}' or ${GSMDATAConsumerCheckList[datasetIndex]} is null`)
				} else {
					GetConsumerIncolumeName(false, GSMDATAConsumerCheckList[datasetIndex], DATA_point, `DATE(${GSMDATAConsumerCheckList[datasetIndex]})='${moment(dateInLong[index], 'DD-MM-YYYY').format('YYYY-MM-DD')}' `)
				}
			}
			} else {
				onHandalGsmChart(GSMDATList[datasetIndex], AllGSMChartData.SRNO[index], false)
			}
		}
	}

	const onClickInstall = (event) => {
		// console.log(getElementsAtEvent(chartRef.current, event));
		const { datasetIndex, index } = getElementAtEvent(InstallChartRef.current, event)[0] || {};
		// console.log((getElementAtEvent(chartRef.current, event)[0]));
		const DATA_point = installData[index].dates ? moment(installData[index].dates).format('YYYY-MM-DD') : ''
		console.log(datasetIndex, index, event, DATA_point)
		if (DATA_point) {
			GetConsumerIncolumeName('NO', `DATE(STR_TO_DATE(INSTALLATION_DETAILS->>'$.Installation_Date_And_Time','%d-%m-%Y'))`, `Installation Date(${moment(DATA_point).format('DD-MM-YYYY')})`, `DATE(STR_TO_DATE(INSTALLATION_DETAILS->>'$.Installation_Date_And_Time','%d-%m-%Y'))='${DATA_point}'`)
		}
	}

	const onExClickInstall = (event) => {
		// console.log(getElementsAtEvent(chartRef.current, event));
		const { datasetIndex, index } = getElementAtEvent(expandChartRef.current, event)[0] || {};
		// console.log((getElementAtEvent(chartRef.current, event)[0]));
		const DATA_point = exInstallationChartData?.date[index] ? moment(exInstallationChartData?.date[index],'DD-MM-YYYY').format('YYYY-MM-DD') : ''
		console.log(datasetIndex, index, event, DATA_point,exInstallationChartData)
		if (DATA_point) {
			GetConsumerIncolumeName('NO', `DATE(STR_TO_DATE(INSTALLATION_DETAILS->>'$.Installation_Date_And_Time','%d-%m-%Y'))`, `Installation Date(${moment(DATA_point).format('DD-MM-YYYY')})`, `DATE(STR_TO_DATE(INSTALLATION_DETAILS->>'$.Installation_Date_And_Time','%d-%m-%Y'))='${DATA_point}'`)
		}
	}

	const onExClickGSMCount = (event) => {
		// console.log(getElementsAtEvent(chartRef.current, event));
		const { datasetIndex, index } = getElementAtEvent(expandChartRef.current, event)[0] || {};
		// console.log((getElementAtEvent(chartRef.current, event)[0]));
		console.log(datasetIndex, index,exGSMCountGroup?.total?.SRNO)
		const srno = exGSMCountGroup?.total?.SRNO[index]
		var col=""
		if(datasetIndex==0){
			col="HEARTBEAT_SUCCESS_LIST,HEARTBEAT_FAIL_LIST"
			setModelId(`Active(Live)(${exGSMCountGroup?.date[index]})`)
		}else if(datasetIndex==1){
			col='HEARTBEAT_SUCCESS_LIST,HEARTBEAT_FAIL_LIST'
			setModelId(`Active(Temporary Disconnect)(${exGSMCountGroup?.date[index]})`)
		}else if(datasetIndex==2){
			col='INACTIVE_CONS_LIST'
			setModelId(`InActive(Permanent Disconnect)(${exGSMCountGroup?.date[index]})`)
		}else if(datasetIndex==3){
			col='PENDING_CONFIGURATION_CONS_LIST'
			setModelId(`Pendding Configuration(${exGSMCountGroup?.date[index]})`)
		}else if(datasetIndex==4){
			col='UNDER_MAINTANANCE_CONS_LIST'
			setModelId(`Under Maintanance(${exGSMCountGroup?.date[index]})`)
		}
		setModalLoad(true)
		setIsModalVisible(true)
		
		setTimeout(async () => {
			settabShow(true)
			
			const data = await gsm_instantaneous_day_wise_graph_details({ colName: col, SRNO: srno, changeTable: false, CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, CATEGORY3: Profile.division, CATEGORY4: Profile.subdivision, CATEGORY5: Profile.area, ROLES: userInfo?.ROLE, serach: Profile.account === '' && Profile.ga === '' && Profile.circle === '' && Profile.division === '' && Profile.subdivision === '' && Profile.area === '' ? false : true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } })
			if (data.success === true) {
				setModalLoad(false)
				if(datasetIndex==0){
					setTableDataInApi([...JSON.parse(data.data.data[0]['HEARTBEAT_SUCCESS_LIST'] || '[]').filter((item) => (item.CONSUMER_SUB_STATUS==1)),...JSON.parse(data.data.data[0]['HEARTBEAT_FAIL_LIST'] || '[]').filter((item) => (item.CONSUMER_SUB_STATUS==1))])
				}else if(datasetIndex==1){
					setTableDataInApi([...JSON.parse(data.data.data[0]['HEARTBEAT_SUCCESS_LIST'] || '[]').filter((item) => (item.CONSUMER_SUB_STATUS==2 )),...JSON.parse(data.data.data[0]['HEARTBEAT_FAIL_LIST'] || '[]').filter((item) => (item.CONSUMER_SUB_STATUS==2))])
				}else if(datasetIndex==2){
					setTableDataInApi(JSON.parse(data.data.data[0]['INACTIVE_CONS_LIST'] || '[]').map((item) => ({ UNIQUE_ID: item?.UNIQUE_ID, DEVICE_SERIAL_NO: item?.DEVICE_SERIAL_NO, address_compony_name: item?.address_compony_name, RSSI: item?.HEARTBEAT_LAST_DATA?.GSM_RSSI })))
				}else if(datasetIndex==3){
					setTableDataInApi(JSON.parse(data.data.data[0]['PENDING_CONFIGURATION_CONS_LIST'] || '[]').map((item) => ({ UNIQUE_ID: item?.UNIQUE_ID, DEVICE_SERIAL_NO: item?.DEVICE_SERIAL_NO, address_compony_name: item?.address_compony_name, RSSI: item?.HEARTBEAT_LAST_DATA?.GSM_RSSI })))
				}else if(datasetIndex==4){
					setTableDataInApi(JSON.parse(data.data.data[0]['UNDER_MAINTANANCE_CONS_LIST'] || '[]').map((item) => ({ UNIQUE_ID: item?.UNIQUE_ID, DEVICE_SERIAL_NO: item?.DEVICE_SERIAL_NO, address_compony_name: item?.address_compony_name, RSSI: item?.HEARTBEAT_LAST_DATA?.GSM_RSSI })))
				}
				
			} else {
				console.log('something want wrong')
				setModalLoad(false)

			}
		}, 100);
	}
	// const myChart = chartRef.current;
	// setTimeout(() => {
	// 	myChart.zoom(2);
	// 	myChart.update()
	// 	// myChart.pan({
	// 	// 	x: Number.MAX_SAFE_INTEGER
	// 	// }, undefined, 'default');
	// })



	const onClickForEvent = (event) => {
		const { datasetIndex, index } = getElementAtEvent(eventChartRef.current, event)[0] || {};
		const DATA_point = GSMEventList[datasetIndex]
		if (DATA_point) {
			if (index === 6) {
				if (DATA_point === 'HEARTBEAT_FAIL_LIST' || DATA_point === 'INSTANTANEOUS_FAIL_LIST' || DATA_point === 'DAILY_LOAD_FAIL_LIST' || DATA_point === 'LOAD_SURVEY_FAIL_LIST' || DATA_point === 'MONTH_BILL_FAIL_LIST') {
					GetConsumerIncolumeName(false, GSMEventConsumerCheckList[datasetIndex], DATA_point, `DATE(${GSMEventConsumerCheckList[datasetIndex]})!='${moment(DateEventInLong[index], 'DD-MM-YYYY').format('YYYY-MM-DD')}'`)
				} else {
					GetConsumerIncolumeName(false, GSMEventConsumerCheckList[datasetIndex], DATA_point, `DATE(${GSMEventConsumerCheckList[datasetIndex]})='${moment(DateEventInLong[index], 'DD-MM-YYYY').format('YYYY-MM-DD')}'`)
				}
			} else {
				onHandalGsmChart(DATA_point, AllGSMEventChartData.SRNO[index], false)
			}
		}
	}

	const [zoomInEnable, setzoomInEnable] = useState(false)
	const [zoomOutEnable, setzoomOutEnable] = useState(false)

	const optionsExpanded = useMemo(() => ({
		// parsing: false,
		responsive: true,
		maintainAspectRatio: false,
		scales: {
			x: {
				// type: 'time',
				ticks: {
					maxRotation: 90,
					minRotation: 90,
					font: {
						size: 10
					},
				}
			},

			y: {
				beginAtZero: true
			},
		},

		// parsing: false,
		plugins: {
			// decimation: {
			// 	enabled: true,
			// 	algorithm: 'lttb',
			// 	samples: 800,
			// 	threshold: 800
			// },
			legend: {
				position: 'bottom',
				labels: {
					pointStyleWidth: 10,
					usePointStyle: true,
					pointStyle: 'rectRounded'
				}
			},
			zoom: {
				zoom: {
					// onZoomComplete: ({
					// 	chart
					// }) => {
					// 	const xMin = chart.scales.x.getLabelForValue(chart.scales.x.min);
					// 	const xMax = chart.scales.x.getLabelForValue(chart.scales.x.max);
					// 	const yMin = chart.scales.y.min;
					// 	const yMax = chart.scales.y.max;
					// 	if (chart.scales.x._valueRange === chart.data.labels.length) {
					// 		setzoomOutEnable(false)
					// 		console.log("disable Zoom Out")
					// 	} else {
					// 		setzoomOutEnable(true)
					// 	}
					// 	if (chart.scales.x.min === chart.scales.x.max) {
					// 		setzoomInEnable(false)
					// 		console.log("disable Zoom in")
					// 	}
					// 	else {
					// 		setzoomInEnable(true)
					// 	}
					// 	// console.log("x values min max == ", chart.scales.x.min, chart.scales.x.max)
					// 	// console.log("Zoom === ", xMin, xMax, yMin, yMax)
					// },
					wheel: {
						enabled: true,
					},
					mode: "x",
				},
				pan: {
					enabled: true,
					mode: "x",
				}
			},
			datalabels: {
				align: 'end',
				anchor: 'end',
				clamp: true,
				color: "black",
				padding: {
					top: 0,
					bottom: 0
				},
				font: function (context) {
					var w = context.chart.width;
					var max = context.chart.scales.x.ticks.length
					return {
						// size: w < 512 ? 8 : 10,
						size: max < 15 ? 10 : 8
					};
				},

			}
		},
		layout: {
			padding: {
				top: 20
			}
		},
	}), [expandedChartData])

	const exInstantData = {
		labels: expandedChartData?.date.map((item)=>([item+` (${moment(item,'DD-MM-YYYY').format('ddd')})`])),
		datasets: [
			{
				label: "Heartbeat Success",
				data: expandedChartData?.total?.heartbeat_success,
				backgroundColor: 'rgb(0, 126, 51)',
				barPercentage: 1.0,
				borderRadius: 5,
			},
			{
				label: "Heartbeat fail",
				data: expandedChartData?.total?.heartbeat_fail,
				barPercentage: 1.0,
				backgroundColor: 'rgb(50,225,79)',
				borderRadius: 5,
			},

			{
				label: "DailyData Success",
				data: expandedChartData?.total?.daily_success,
				barPercentage: 1.0,
				backgroundColor: 'rgb(51,33,113)',
				borderRadius: 5,
			},
			{
				label: "DailyData Fail",
				data: expandedChartData?.total?.daily_fail,
				barPercentage: 1.0,
				backgroundColor: 'rgb(120,111,206)',
				borderRadius: 5,
			},
			{
				label: "Hourly Success",
				data: expandedChartData?.total?.load_success,
				barPercentage: 1.0,
				backgroundColor: 'rgb(255, 119, 0)',
				borderRadius: 5,
			},
			{
				label: "Hourly Fail",
				data: expandedChartData?.total?.load_fail,
				barPercentage: 1.0,
				backgroundColor: 'rgb(240, 193, 91)',
				borderRadius: 5,
			}, {
				label: "Alert",
				data: expandedChartData?.total?.alert_count,
				barPercentage: 1.0,
				backgroundColor: 'rgb(120,111,206)',
				borderRadius: 5,
			},
			{
				label: "EVC communication Fail",
				data: expandedChartData?.total?.meter_comm_fail_count,
				barPercentage: 1.0,
				backgroundColor: 'rgb(255, 69, 96)',
				borderRadius: 5,
			}
		],
	};

	const exEventChartJsData = {
		labels: exEventChartData?.date,
		datasets: [
			{
				label: "Volt Event",
				barPercentage: 1.0,
				data: exEventChartData?.total?.volt,
				backgroundColor: 'rgb(0, 126, 51)',
				borderRadius: 5,
			},
			{
				label: "Current Event",
				data: exEventChartData?.total?.current,
				barPercentage: 1.0,
				backgroundColor: 'rgb(50,225,79)',
				borderRadius: 5,
			},
			{
				label: "Power Event",
				data: exEventChartData?.total?.power,
				backgroundColor: 'rgb(0,104,138)',
				barPercentage: 1.0,
				borderRadius: 5,
			},
			{
				label: "Other Event",
				data: exEventChartData?.total?.other,
				backgroundColor: 'rgb(85, 200, 245)',
				barPercentage: 1.0,
				borderRadius: 5,
			},
			{
				label: "Transaction Event",
				data: exEventChartData?.total?.transection,
				backgroundColor: 'rgb(255, 119, 0)',
				barPercentage: 1.0,
				borderRadius: 5,
			}, {
				label: "Nonrollover Event",
				data: exEventChartData?.total?.nonrollover,
				backgroundColor: 'rgb(240, 193, 91)',
				barPercentage: 1.0,
				borderRadius: 5,
			}, {
				label: "Control Event",
				data: exEventChartData?.total?.control,
				backgroundColor: 'rgb(51,33,113)',
				borderRadius: 5,
				barPercentage: 1.0,

			}
		]
	}

	const exMonthBillChartJSData = {
		labels: exMonthBillChartData?.date,
		datasets: [
			{
				label: "Monthly Success",
				barPercentage: 1.0,
				data: exMonthBillChartData?.total?.month_success,
				backgroundColor: 'rgb(0, 126, 51)',
				borderRadius: 5,
			},
			{
				label: "Monthly Fail",
				data: exMonthBillChartData?.total?.month_fail,
				barPercentage: 1.0,
				backgroundColor: 'rgb(50,225,79)',
				borderRadius: 5,
			}
		]
	}


	const exInstallChartJs = {
		labels: exInstallationChartData?.date.map((item)=>([item+` (${moment(item,'DD-MM-YYYY').format('ddd')})`])),
		datasets: [
			{
				label: "Installation",
				data: exInstallationChartData?.barData,
				backgroundColor: 'rgb(0, 200, 81)'
			}
		]
	}
	const exInstallOptionChartJS = {
		responsive: true,
		maintainAspectRatio: false,
		animation: {
			duration: 0
		},

		plugins: {
			legend: {
				position: 'bottom',
				labels: {
					pointStyleWidth: 10,
					usePointStyle: true,
					pointStyle: 'rectRounded'
				}
			},
			zoom: {
				zoom: {
					wheel: {
						enabled: true // SET SCROOL ZOOM TO TRUE
					},
					mode: "x",
				},
				pan: {
					enabled: true,
					mode: "x",
				}
			},
			datalabels: {
				align: 'end',
				anchor: 'end',
				clamp: true,
				color: "black",
				padding: {
					top: 0,
					bottom: 0
				},
				font: function (context) {
					var w = context.chart.width;
					return {
						size: w < 512 ? 10 : 12,

					};
				},

			}
		},
		layout: {
			padding: {
				left: 50,
				right: 50,
				top: 20
			}
		},
		// onClick: (event) => {
		// 	console.log(getElementAtEvent(chartRef.current, event));
		// 	console.log("first")
		// 	// getElementsAtEvent(elements)
		// 	// const chart = chartRef.current;
		// 	// const element = chart.getElementAtEvent(event)[0];
		// 	// const dataset = chart.data.datasets[element._datasetIndex];
		// 	// const xLabel = chart.data.labels[element._index];
		// 	// const value = dataset.data[element._index];
		// 	// console.log(dataset.label + " at " + xLabel + ": " + value);
		// },
	};

	const exGSMCountJsData = {
		labels: exGSMCountGroup?.date,
		datasets: [
			{
				label: "Active(Live)",
				barPercentage: 1.0,
				data: exGSMCountGroup?.total?.active_Live_count,
				backgroundColor: 'rgb(84 202 104)',
				borderRadius: 5,
			},
			{
				label: "Active(Temporary Disconnection)",
				barPercentage: 1.0,
				data: exGSMCountGroup?.total?.active_TD_count,
				backgroundColor: 'rgb(134 239 172)',
				borderRadius: 5,
			},
			{
				label: "Inactive(Permanent Disconnection)",
				data: exGSMCountGroup?.total?.inactive_count,
				barPercentage: 1.0,
				backgroundColor: 'rgb(255 69 96)',
				borderRadius: 5,
			},
			{
				label: "Pending Configuration",
				data: exGSMCountGroup?.total?.pending_count,
				backgroundColor: 'rgb(254 176 25)',
				barPercentage: 1.0,
				borderRadius: 5,
			},
			{
				label: "Under Maintanace",
				data: exGSMCountGroup?.total?.undermaintanace_count,
				backgroundColor: 'rgb(0 143 251)',
				barPercentage: 1.0,
				borderRadius: 5,
			}
		]
	}

	const expandChartRef = useRef()
	const myChart = expandChartRef.current;
	let midValue = 0
	if (myChart != undefined || myChart != null) {
		const xMin = myChart.scales.x.min;
		const xMax = myChart.scales.x.max;
		console.log("minMax == ", xMin, xMax)
		midValue = xMax / 2
	}

	const zoomIn = () => {
		if (myChart != undefined || myChart != null) {
			myChart.zoom(1.2);
		}
	}
	const zoomOut = () => {
		if (myChart != undefined || myChart != null) {
			myChart.zoom(0.8);
		}
	}

	const panLeft = () => {
		if (myChart != undefined || myChart != null) {
			myChart.pan({ x: 400 }, undefined, 'default');
		}
	}
	const panRight = () => {
		if (myChart != undefined || myChart != null) {
			myChart.pan({ x: -400 }, undefined, 'default');
		}
	}
	useEffect(()=>{
		setTimeout(() => {
			if (myChart != undefined || myChart != null) {
				myChart.zoomScale('x', { min: midValue - 3, max: midValue + 3 }, 'default')
				console.log("midaVAlue in setTimeout == ", Math.round(midValue))
				// myChart.zoom(1.2);
				// myChart.pan({
				// 	x: 500
				// }, undefined, 'default');
	
				// myChart.pan({
				// 	x: - (Number.MAX_SAFE_INTEGER)
				// }, undefined, 'default');
	
			}
		}, 20)
	},[myChart])
	

	const [activeTab, setActiveTab] = useState("Device Dashboard");
	const [lastSeenType, setLastSeenType] = useState("byHours");
	// const { isLoaded } = useLoadScript({
	// 	// Enter your own Google Maps API key
	// 	googleMapsApiKey: "AIzaSyD07E1VvpsN_0FvsmKAj4nK9GnLq-9jtj8"
	//   });
	const onModelOpenAndCheckDate = async () => {
		const data = await getStartAndEndDateByTable({ tableName: 'gsm_consumer_device_index', col: 'HEARTBEAT_TS' })
		if (data.success === true) {
			console.log("Expiry Dates == ", data.data)
			setExpireDate(data.data)
			setIsLastModalVisible(true)
		} else {
			console.log("something want wrong")
		}
	}
	const customStyles = {
		menu: provided => ({ ...provided, zIndex: 9999 }),
		multiValue: (provided, { data }) => {
			return {
				...provided,
				width: 'min-content',
				backgroundColor: "#6777ef",
			};
		},
		multiValueLabel: (styles, { data }) => ({
			...styles,
			color: "white",
		}),
	}
	const animatedComponents = makeAnimated();

	const Download_Logs=()=>{
        exportExcelDownload(TableData.map((item,id)=>({"SRNO":id + 1,"Consumer Name":item?.address_compony_name})),ModelId+(new Date().valueOf()))
    }
	return (
		<>
		{/* <Link to={{  pathname: `All-GSM`,state: { detail: TableData.map((data)=>(data?.UNIQUE_ID)) }  }}></Link> */}
				{<Suspense fallback={<><Spin size="large" /></>}>
				<BootstrapModal className="my-modal-class" show={isModalVisible} onHide={handleCancel} size={"xl"} >
					<BootstrapModal.Header closeButton><BootstrapModal.Title style={{ fontSize: '1.25rem', fontWeight: 'bold' }}>
						{ModelId}{TableData.length > 0?<span className='btn btn-primary text-white ml-2' onClick={Download_Logs}><i className='fas fa-download'></i></span>:''}
						{TableData.length > 0?<Link to={{  pathname: `All-GSM`,state: { detail: TableData.map((data)=>(data?.UNIQUE_ID)),title:ModelId }  }}><span className='btn btn-primary text-white ml-2'><i className='fas fa-up-right-from-square'></i></span></Link>:''}
					</BootstrapModal.Title></BootstrapModal.Header>
					<BootstrapModal.Body style={{ maxHeight: '90vh', overflow: 'auto', paddingTop: '0px' }}>
						<div className="modal-table">
							{ModalLoad ? (
								<div className="example">
									<Spin size="large" />
								</div>
							) : <table className="table border table-borderless" id="table-1">
								<thead style={{ position: 'sticky', top: '0', background: '#fff' }}>
									<tr>
										<th className="text-center">SR NO.</th>
										<th className="text-center">Consumer Name</th>
										<th className="text-center">Meter Serial No</th>
										<th className="text-center">Category</th>
										{tabShow === true ? '' :<th className="text-center">EVC Type</th>}
										{tabShow === false&&ModelId=='Under Maintanance' ? <th className="text-center">Change Status Time</th>:''}
									</tr>
								</thead>
								<tbody id="tbody">
									<>
										{TableData.length > 0 ?
											TableData.map((data, id) => (
												<tr style={{ height: "4rem", cursor: 'pointer' }} className="trheigth even:tw-bg-gray-100 hover:tw-bg-[#D8D8D8]" key={id} onClick={() => onHandaleViewGSM(data?.UNIQUE_ID)}>
													<td className="text-center">{id + 1}</td>
													<td className="text-center">{data?.address_compony_name}</td>
													<td className="text-center">{data?.MECHENICAL_SERIAL_NUMBER}</td>
													{/* <BootstrapTooltip title={<div>
																	ACCOUNT:{AllCategory?.category0.filter((inac) => (inac?.UNIQUE_ID === data?.CAT0_ID))[0]?.CATEGORY0}
																	<br />
																	CATEGORY1:{AllCategory?.category1.filter((inac) => (inac?.CATEGORY1_UNIQUE_ID === data?.CAT1_ID))[0]?.CATEGORY1_NAME}
																	<br />
																	CATEGORY2:{AllCategory?.category2.filter((inac) => (inac?.CATEGORY2_UNIQUE_ID === data?.CAT2_ID))[0]?.CATEGORY2_NAME}
																	<br />
																	CATEGORY3:{AllCategory?.category3.filter((inac) => (inac?.CATEGORY3_UNIQUE_ID === data?.CAT3_ID))[0]?.CATEGORY3_NAME}
																	<br />
																	CATEGORY4:{AllCategory?.category4.filter((inac) => (inac?.CATEGORY4_UNIQUE_ID === data?.CAT4_ID))[0]?.CATEGORY4_NAME}
																	<br />
																	CATEGORY5:{AllCategory?.category5.filter((inac) => (inac?.UNIQUE_ID === data?.CAT5_ID))[0]?.NAME}
																</div>} placement='top'><td className="text-center"><b className='tw-font-semibold '>ACCOUNT:</b><br />{AllCategory?.category0.filter((inac) => (inac?.UNIQUE_ID === data?.CAT0_ID))[0]?.CATEGORY0}</td></BootstrapTooltip> */}
																<td className='tw-min-w-[150px] text-center' >
														{AllCategory?.category5.filter((inac) => (inac?.UNIQUE_ID === data?.CAT5_ID))[0]?.NAME || AllCategory?.category4.filter((inac) => (inac?.CATEGORY4_UNIQUE_ID === data?.CAT4_ID))[0]?.CATEGORY4_NAME || AllCategory?.category3.filter((inac) => (inac?.CATEGORY3_UNIQUE_ID === data?.CAT3_ID))[0]?.CATEGORY3_NAME || AllCategory?.category2.filter((inac) => (inac?.CATEGORY2_UNIQUE_ID === data?.CAT2_ID))[0]?.CATEGORY2_NAME || AllCategory?.category1.filter((inac) => (inac?.CATEGORY1_UNIQUE_ID === data?.CAT1_ID))[0]?.CATEGORY1_NAME || AllCategory?.category0.filter((inac) => (inac?.UNIQUE_ID === data?.CAT0_ID))[0]?.CATEGORY0}
													</td>
																{tabShow === true ? '' :<td className="text-center">{MeterDetails.filter((info)=>(info?.METER_TYPE==data?.METER_TYPE))[0]?.METER_PROFILE_NAME||''}</td>}

													{tabShow === false&&ModelId=='Under Maintanance' ?  <td className="text-center"><BootstrapTooltip title={data?.CHANGE_STATUS_TS ?moment.utc(data.CHANGE_STATUS_TS).format('DD-MM-YYYY hh:mm:ss A'):''}><div className="badge badge-success badge-shadow text-white" >{data?.CHANGE_STATUS_TS ? moment.utc(data.CHANGE_STATUS_TS).add(-moment().utcOffset(), "m").fromNow('ss:hh:mm') : ''}</div></BootstrapTooltip></td>:''}
												</tr>
											)) : <tr></tr>}
									</>
								</tbody>
							</table>}
							{TableData.length === 0 && !ModalLoad && <h4 className="text-center">No Data Found</h4>}
						</div>
					</BootstrapModal.Body>
				</BootstrapModal>
			</Suspense>
			}

			<Modal title={"Last Seen"} visible={isLastModalVisible} maskClosable={false} footer='' onCancel={() => {
				setIsLastModalVisible(false)
				setDates({ start: '', end: '' })
			}} width={500} height={300}>
				<div class="form-group text-left">
					<input type="radio"
						name="login_type"
						id="byHours"
						onChange={() => setLastSeenType("byHours")}
						style={{ height: "16px", width: "20px", verticalAlign: "middle" }}
						checked={lastSeenType === "byHours" ? true : false} /><label for="byHours" className="mr-2" style={{ marginLeft: "5px" }}>By Hours</label>
					<input type="radio"
						name="login_type"
						id="byIntervals"
						onChange={() => setLastSeenType("byIntervals")}
						style={{ height: "16px", width: "20px", verticalAlign: "middle" }}

						checked={lastSeenType === "byIntervals" ? true : false} /><label for="byIntervals" style={{ marginLeft: "5px" }}>By Interval</label>
				</div>
				{/* <div class="form-group tw-flex tw-gap-2 tw-p-0 tw-m-0">
					<div className="tw-py-2  tw-flex tw-items-center tw-pl-4 tw-rounded tw-border-solid tw-border tw-border-gray-200 ">
						<input className="tw-w-6 tw-h-6 "
							type="radio"
							name="login_type"
							id="byHours"
							onChange={() => setLastSeenType("byHours")}
							checked={lastSeenType === "byHours" ? true : false}
						/>
						<label className="tw-mb-0 tw-ml-2 tw-w-full tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-gray-300" for="byHours">
							By Hours
						</label>
					</div>
					<div className="tw-py-2 tw-w-full tw-flex tw-items-center tw-pl-4 tw-rounded tw-border-solid  tw-border tw-border-gray-200 ">
						<input className="tw-w-6 tw-h-6 "
							type="radio"
							name="login_type"
							id="byIntervals"
							onChange={() => setLastSeenType("byIntervals")}
							checked={lastSeenType === "byIntervals" ? true : false}
						/>
						<label className="tw-mb-0 tw-ml-2 tw-w-full tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-gray-300" for="byIntervals">
							By Interval
						</label>
					</div>
				</div> */}
				{lastSeenType === 'byHours' ?
					<div className="tw-flex">
						<div class="form-group col-md-9 tw-p-0">
							<input type="text" id="last_seen_hours" name="last_seen_hours" class="form-control" required="" placeholder="Last Seen Hour" value={inputSeen} onChange={(e) => (setinputSeen(e.target.value))} />
						</div>

						<div class="form-group col-md-3">
							<label htmlFor="last_seen_hours">&nbsp;&nbsp;<br /></label>

							<input type="button" class="btn btn-danger" value="Submit" id="last_seen_btn" name="last_seen_btn" onClick={() => (inputSeen ? window.open(`/gsm-map-view?last_seen=${inputSeen}`, '_blank') : {})} />
						</div>
					</div>
					:
					<div className="pb-3">
						<div className="d-flex tw-justify-between tw-items-center">
							<div className="d-flex tw-justify-center tw-items-end">
								<Space direction="horizontal">
									<div className="d-flex flex-column">Start Date
										<DatePicker format='DD-MM-YYYY' name='start' onChange={onChangeMap} disabledDate={(current) => {
											return (moment(expireDate.start_date).add(-1, 'days') >= current) || (moment(expireDate.end_date).add(0, 'days') <= current);
										}} />
									</div>
									<div className="d-flex flex-column" >End Date
										<DatePicker name='end' format='DD-MM-YYYY' onChange={onChangesMap} disabledDate={(current) => {
											return (moment(expireDate.start_date).add(-1, 'days') >= current) || (moment(expireDate.end_date).add(0, 'days') <= current);
										}} />
									</div>
								</Space>
							</div>
							<div>
								<a className={`btn btn-danger text-white`} onClick={() => (datesInmap.start && datesInmap.end ? window.open(`/gsm-map-view?date=${JSON.stringify(datesInmap)}`, '_blank') : {})}>Submit</a>
							</div>
						</div>
					</div>}
			</Modal>

			<Modal title={expandedModelHeader} visible={isExpandedModalOpen} maskClosable={false} footer='' onCancel={handleExpandedModal} width={1500}>

				<div className="d-flex tw-justify-between tw-items-center">
					<div className="d-flex tw-justify-center tw-items-end">
						{expandedModelHeader == 'GSM Month Bill Count' ?
							<Space direction="horizontal">
								<div className="d-flex flex-column">Start In
									<DatePicker value={dates?.start !== '' ? moment(dates.start, "MM-YYYY") : null} onChange={onChange} format='MM-YYYY' name='start' picker="month" /></div>
								<div className="d-flex flex-column" >End In
									<DatePicker value={dates?.end !== '' ? moment(dates?.end, "MM-YYYY") : null} onChange={onChanges} name='end' format='MM-YYYY' picker="month" /></div>
							</Space>

							: <Space direction="horizontal">
								<div className="d-flex flex-column">Start In
									<DatePicker value={dates?.start !== '' ? moment(dates?.start, "DD-MM-YYYY") : null} onChange={onChange} format='DD-MM-YYYY' name='start' disabledDate={(current) => {
										return (moment(expireDate.start_date).add(-moment().utcOffset(), "m").add(-1, 'days') >= current) || (moment.utc(expireDate.end_date).add(-moment().utcOffset(), "m").add(0, 'days') <= current);
									}} /></div>
								<div className="d-flex flex-column" >End In
									<DatePicker value={dates?.end !== '' ? moment(dates?.end, "DD-MM-YYYY") : null} onChange={onChanges} name='end' format='DD-MM-YYYY' disabledDate={(current) => {
										return (moment(expireDate.start_date).add(-moment().utcOffset(), "m").add(-1, 'days') >= current) || (moment.utc(expireDate.end_date).add(-moment().utcOffset(), "m").add(0, 'days') <= current);
									}} /></div>
							</Space>}

						<div className='d-flex'>
							<a className={`btn btn-danger text-white ml-3 ${ChartLoader ? 'btn-progress disabled' : ''}`} onClick={() => (onExpandSubmitClick())}>Submit</a>
							{exInstallationChartData?.date.length>0&&<h5 className='ml-2'>(Total Count : {sum(exInstallationChartData?.barData)})</h5>}
						</div>

					</div>

					{exInstallationChartData?.date.length || expandedChartData.date.length > 0 || exMonthBillChartData.date.length > 0 || exEventChartData.date.length > 0 ?
						<div>
							<div className="tw-mb-1">
								<small className='tw-text-red-300'><sup className="tw-text-sm !tw-top-0">*</sup> You can also do Zoom and Scroll using your mouse</small>
							</div>
							<div className="tw-flex tw-justify-end tw-items-center">
								<button className={`tw-rounded-lg tw-bg-indigo-500 tw-border-transparent text-white tw-mx-1 tw-p-1`} disabled={zoomInEnable} onClick={zoomIn}><BootstrapTooltip title="ZoomIn">
									<div className="tw-flex tw-items-center fa-lg">
										<i class="fas fa-search-plus" aria-hidden="true"></i>
									</div>
								</BootstrapTooltip>
								</button>
								<button className={`tw-rounded-lg tw-bg-indigo-500 tw-border-transparent text-white tw-mx-1 tw-p-1`} disabled={zoomOutEnable} onClick={zoomOut}>
									<BootstrapTooltip title='ZoomOut'>
										<div className="tw-flex tw-items-center fa-lg">
											<i class="fas fa-search-minus" aria-hidden="true"></i>
										</div>
									</BootstrapTooltip>
								</button>

								<button className="tw-rounded-lg tw-bg-indigo-500 tw-border-transparent text-white tw-mx-1 tw-py-1 tw-px-2" onClick={panLeft}>
									<BootstrapTooltip title='Left scroll'>
										<div className="tw-flex tw-items-center fa-lg">
											<i class="fas fa-caret-left" aria-hidden="true"></i>
										</div>
									</BootstrapTooltip>
								</button>
								<button className="tw-rounded-lg tw-bg-indigo-500 tw-border-transparent text-white tw-mx-1 tw-py-1 tw-px-2" onClick={panRight}>
									<BootstrapTooltip title='Right scroll'>
										<div className="tw-flex tw-items-center fa-lg">
											<i class="fas fa-caret-right" aria-hidden="true"></i>
										</div>
									</BootstrapTooltip>
								</button>
							</div>

						</div>
						: ''}
				</div>

				{expandedChartData.date.length > 0 ? <div className=" tw-mt-2 tw-h-[560px] tw-max-h-screen tw-px-5"><Bar ref={expandChartRef} options={optionsExpanded} data={exInstantData} /> </div> : ''}

				{exMonthBillChartData.date.length > 0 ? <div className="tw-mt-2 tw-h-[560px] tw-max-h-screen tw-px-5"><Bar ref={expandChartRef} options={optionsExpanded} data={exMonthBillChartJSData} /> </div> : ''}

				{exEventChartData.date.length > 0 ? <div className="tw-mt-2 tw-h-[560px] tw-max-h-screen tw-px-5"><Bar ref={expandChartRef} options={optionsExpanded} data={exEventChartJsData} /> </div> : ''}

				{exInstallationChartData?.date.length>0 ? <div className="tw-mt-2 tw-h-[560px] tw-max-h-screen tw-px-5"><Bar ref={expandChartRef} options={exInstallOptionChartJS} data={exInstallChartJs} onClick={onExClickInstall}/> </div> : ''}

				{exGSMCountGroup?.date.length>0 ? <div className="tw-mt-2 tw-h-[560px] tw-max-h-screen tw-px-5"><Bar ref={expandChartRef} options={optionsExpanded} data={exGSMCountJsData} onClick={onExClickGSMCount}/> </div> : ''}
				{expandedChartData.date.length == 0 &&exMonthBillChartData.date.length==0&&exEventChartData.date.length== 0&&exInstallationChartData?.date.length==0 &&exGSMCountGroup?.date.length==0?'':''}
			</Modal>

			<div className="main-content">
				{loader ? (
					<div className="main-content">
						<div class="loader"></div>
					</div>
				) : (
					""
				)}
				<nav aria-label="breadcrumb">
					<ol className="breadcrumb">
						<li className="breadcrumb-data">
							<Link to="/all-dashboard">
								<i className="fas fa-tachometer-alt"></i> Home/
							</Link>
						</li>
						<li className="breadcrumb-data">
							<Link to='/gsm_dashboard'>GSM Dashboard</Link>
						</li>
					</ol>
				</nav>
				<section class="section">
					<div class="section-body">
						<div class="row">

							<div class="col-12 col-sm-12 col-lg-12 tw-p-0">
								<div class="card ">
									<div class="card-header d-flex tw-border-b-0 " style={{ justifyContent: 'space-between' }}>
										<ul class="nav nav-pills tw-gap-2" role="tablist" style={{ lineHeight: '20px', alignItems: 'center' }}>
											<li>
												<button style={{
														backgroundColor: activeTab === "Device Dashboard" ? chroma(btnColor[0]).alpha(0.4).css() : '',
														color:activeTab === "Device Dashboard" ? chroma(btnColor[0]).darken(1.5).css() : btnColor[0],
														borderBottom: `1px solid ${btnColor[0]}`,
														boxShadow: activeTab === "Device Dashboard" ? `0 2px 8px -3px ${btnColor[0]}` : '',
													}}
														className={`tw-font-semibold tw-transition-all tw-bg-transparent tw-border-t-0 tw-border-r-0 tw-border-l-0 ml-2 tw-px-2 tw-mx-1 tw-my-1 tw-py-1 md:tw-px-3 md:tw-m-0 md:tw-py-2 focus:tw-outline-none ${activeTab === "Device Dashboard" ? 'tw-rounded' : 'hover:tw-bg-gray-100 hover:tw-rounded'}`} data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true" onClick={() => (setActiveTab('Device Dashboard'))}>Modem Dashboard</button>
											</li>
											<li>
												<button style={{
														backgroundColor: activeTab === "EVC/MC Meter Dashboard" ? chroma(btnColor[2]).alpha(0.4).css() : '',
														color:activeTab === "EVC/MC Meter Dashboard" ? chroma(btnColor[2]).darken(1.5).css() : btnColor[2],
														borderBottom: `1px solid ${btnColor[2]}`,
														boxShadow: activeTab === "EVC/MC Meter Dashboard" ? `0 2px 8px -3px ${btnColor[2]}` : '',
													}}
														className={`tw-font-semibold tw-transition-all tw-bg-transparent tw-border-t-0 tw-border-r-0 tw-border-l-0 ml-2 tw-px-2 tw-mx-1 tw-my-1 tw-py-1 md:tw-px-3 md:tw-m-0 md:tw-py-2 focus:tw-outline-none ${activeTab === "EVC/MC Meter Dashboard" ? 'tw-rounded' : 'hover:tw-bg-gray-100 hover:tw-rounded'}`} id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false" onClick={() => (setActiveTab('EVC/MC Meter Dashboard'))}>EVC/MC Meter Dashboard</button>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>

						{activeTab === 'Device Dashboard' && (<>
							<div class="row">
								<div class="col-12">
									<div class="card ">
										<div class="card-body tw-flex tw-items-center tw-gap-3" style={{ padding: "2px 12px" }}>
											<div class="tw-flex tw-gap-2"
												style={{

													borderColor: "#e3e6fc !important",
													position: "relative",
													marginTop: "5px",
												}}>
												<div class="tw-w-full tw-min-w-[13rem]">
													<div class="form-group">
														<label htmlFor="inputPassword4">
														Account<span class="text-danger">*</span>
														</label>
														{/* <Select name='Consumertype' isMulti options={AccounData.map((data, id) =>
																	permision?.ROLES_PERMISSIONS_CATEGORY0?.CATEGORY0_view?.filter(
																		(items) => items === item.UNIQUE_ID
																	).length > 0 || userInfo?.ROLE === 'ROLE1650614500708' ? (
																		{value:item.UNIQUE_ID,label:item.CATEGORY0}
																	) :{}
																)} onChange={(e) => { setProfile({ ...Profile, account: e.map((item) => (item.value)) }) }} /> */}
														<select
															class="form-control form-select accountoga ga_calueacc"
															name="accountid"
															required=""
															id="accountid"
															onChange={(e) => setProfile({ ...Profile, account: e.target.value })}
															value={Profile?.account}

														>
															<option value="">All Account </option>
															{AccounData &&
																AccounData.map((item, id) =>
																	permision?.ROLES_PERMISSIONS_CATEGORY0?.CATEGORY0_view?.filter(
																		(items) => items === item.UNIQUE_ID
																	).length > 0 || userInfo?.ROLE === 'ROLE1650614500708' ? (
																		<option key={id} value={item.UNIQUE_ID}>{item.CATEGORY0}</option>
																	) : (
																		""
																	)
																)}
														</select>
													</div>
												</div>
												{Profile.account !== "" && (
											<div class="tw-w-full tw-min-w-[12rem] gagrp">
												<div class="form-group">
													<label htmlFor="inputPassword4">{NameObj?.CATEGORY1 || 'CATEGORY1'}</label>
													<select
														class="form-control form-select gatocircle ga_calue"
														name="address_location_d"
														id="address_location_d"
														onChange={(e) => setProfile({ ...Profile, ga: e.target.value, circle: "", division: "", subdivision: "", area: "" })}
														value={Profile?.ga}
													>
														<option value="">Select {NameObj?.CATEGORY1 || 'CATEGORY1'}</option>
														{GaData &&
															GaData.filter(item=>item.CATEGORY0==Profile.account).map((item, id) =>
																permision?.ROLES_PERMISSIONS_CATEGORY1?.CATEGORY1_view?.filter(
																	(items) => items === item.CATEGORY1_UNIQUE_ID
																).length > 0 ||(item.CATEGORY0==Profile?.account)|| userInfo?.ROLE === 'ROLE1650614500708' ? (
																	<option key={id} value={item.CATEGORY1_UNIQUE_ID}>{item.CATEGORY1_NAME}</option>
																) : (
																	""
																)
															)}
													</select>
												</div>
											</div>
										)}
										{Profile.ga !== "" && Profile.account !== "" && (
											<div class="tw-w-full tw-min-w-[12rem] circlegrp">
												<div class="form-group">
													<label htmlFor="inputPassword4">{NameObj?.CATEGORY2 || 'CATEGORY2'}</label>
													<select
														class="form-control circletodivision form-select"
														name="circle_id"
														onChange={(e) => setProfile({ ...Profile, circle: e.target.value, division: "", subdivision: "", area: "" })}
														value={Profile?.circle}
													>
														<option value="">Select {NameObj?.CATEGORY2 || 'CATEGORY2'}</option>
														{CircleData &&
															CircleData.filter(item=>item.CATEGORY1==Profile.ga).map((item, id) =>
																permision?.ROLES_PERMISSIONS_CATEGORY2?.CATEGORY2_view?.filter(
																	(items) => items === item.CATEGORY2_UNIQUE_ID
																).length > 0 ||(item.CATEGORY0==Profile?.account&&item.CATEGORY1==Profile?.ga)|| userInfo?.ROLE === 'ROLE1650614500708' ? (
																	<option key={id} value={item.CATEGORY2_UNIQUE_ID}>{item.CATEGORY2_NAME}</option>
																) : (
																	""
																)
															)}
													</select>
												</div>
											</div>
										)}
										{Profile.circle !== "" && Profile.ga !== "" && Profile.account !== "" && (
											<div class="tw-w-full tw-min-w-[12rem] divisiongrp">
												<div class="form-group">
													<label htmlFor="inputPassword4">{NameObj?.CATEGORY3 || 'CATEGORY3'}</label>
													<select
														class="form-control divisiontosubdivision form-select"
														name="division_id"
														id="address_location_d"
														onChange={(e) => setProfile({ ...Profile, division: e.target.value, subdivision: "", area: "" })}
														value={Profile?.division}
													>
														<option value="">Select {NameObj?.CATEGORY3 || 'CATEGORY3'}</option>
														{DivisionData &&
															DivisionData.filter(item=>item.CATEGORY2==Profile.circle).map((item, id) =>
																permision?.ROLES_PERMISSIONS_CATEGORY3?.CATEGORY3_view?.filter(
																	(items) => items === item.CATEGORY3_UNIQUE_ID
																).length > 0 ||(item.CATEGORY0==Profile?.account&&item.CATEGORY1==Profile?.ga)|| userInfo?.ROLE === 'ROLE1650614500708' ? (
																	<option key={id} value={item.CATEGORY3_UNIQUE_ID}>{item.CATEGORY3_NAME}</option>
																) : (
																	""
																)
															)}
													</select>
												</div>
											</div>
										)}
										{Profile.division !== "" && Profile.circle !== "" && Profile.ga !== "" && Profile.account !== "" && (
											<div class="tw-w-full tw-min-w-[12rem] subdivisiongrp">
												<div class="form-group">
													<label htmlFor="inputPassword4">{NameObj?.CATEGORY4 || 'CATEGORY4'}</label>
													<select
														class="form-control subdivisiontoarea form-select"
														name="sub_division_id"
														id="address_location_d"
														onChange={(e) => setProfile({ ...Profile, subdivision: e.target.value, area: "" })}
														value={Profile?.subdivision}
													>
														<option value="">Select {NameObj?.CATEGORY4 || 'CATEGORY4'}</option>
														{SubdevisionData &&
															SubdevisionData.filter(item=>item.CATEGORY3==Profile.division).map((item, id) =>
																permision?.ROLES_PERMISSIONS_CATEGORY4?.CATEGORY4_view?.filter(
																	(items) => items === item.CATEGORY4_UNIQUE_ID
																).length > 0 ||(item.CATEGORY0==Profile?.account&&item.CATEGORY1==Profile?.ga&&item.CATEGORY2==Profile?.circle&&item.CATEGORY3==Profile?.division)|| userInfo?.ROLE === 'ROLE1650614500708' ? (
																	<option key={id} value={item.CATEGORY4_UNIQUE_ID}>
																		{item.CATEGORY4_NAME}
																	</option>
																) : (
																	""
																)
															)}
													</select>
												</div>
											</div>
										)}
										{Profile.subdivision !== "" &&
											Profile.division !== "" &&
											Profile.circle !== "" &&
											Profile.ga !== "" &&
											Profile.account !== "" && (
												<div class="tw-w-full tw-min-w-[12rem] areagrp">
													<div class="form-group">
														<label htmlFor="inputPassword4">{NameObj?.CATEGORY5 || 'CATEGORY5'}</label>
														<select
															class="form-control form-select lastarea cust_ara"
															name="area_id"
															id="area_id"
															onChange={(e) => setProfile({ ...Profile, area: e.target.value })}
															value={Profile?.area}
														>
															<option value="">Select {NameObj?.CATEGORY5 || 'CATEGORY5'}</option>
															{AreaData &&
																AreaData.filter(item=>item.CATEGORY4==Profile.subdivision).map((item, id) =>
																	permision?.ROLES_PERMISSIONS_CATEGORY5?.CATEGORY5_view?.filter(
																		(items) => items === item.UNIQUE_ID
																	).length > 0 ||(item.CATEGORY0==Profile?.account&&item.CATEGORY1==Profile?.ga&&item.CATEGORY2==Profile?.circle&&item.CATEGORY3==Profile?.division&&item.CATEGORY4==Profile?.subdivision)|| userInfo?.ROLE === 'ROLE1650614500708' ? (
																		<option key={id} value={item.UNIQUE_ID}>{item.CATEGORY5_NAME}</option>
																	) : (
																		""
																	)
																)}
														</select>
													</div>
												</div>
											)}
											</div>
											<div>
												<button class="btn btn-primary" onClick={onProfileWiseSearchClick}> <i className="fa fa-search"></i> </button>
											</div>

										</div>
									</div>

								</div>
							</div>
							

							<div class="row">
								<div class="col-xs-12 col-md-6 ">
									<div class="card card-success">
										<div class="card-header d-flex" style={{ justifyContent:'space-between' }}>
											<h4><span className="mr-2">GSM Consumer Status</span><BootstrapTooltip title='Find Data In gsm_consumer_device_index (CUSTOMER_STATUS)' placement='top'><span><i className='fas fa-info-circle info_circle'></i></span></BootstrapTooltip></h4>
										</div>
										<div class="card-body "
											style={{ position: "relative", paddingLeft: "0px", paddingRight: "0px", height: "395px" }}>
											{tableData.length > 0 && tableData.length > 0 ? <ReactApexChart options={option16} type="pie" series={tableData} height={"350"} /> : <div className="d-flex" style={{ justifyContent: 'center' }}><img class="loader_center text-center" src={loaderGif} /></div>}
										</div>
										<div className="tw-flex tw-justify-between tw-px-3">
											<p>Total Count : {sum(tableData)} </p>
											<p>{'Pie chart(Dynamic)'} </p>
										</div>
									</div>
								</div>
								{permision?.ROLES_OTHER_PERMISSIONS?.GSM_GROUP_DASH?.MODEM?.view?.filter((item) => (item == 'Meter_Profile')).length > 0 || userInfo?.ROLE == 'ROLE1650614500708' ? <div class="col-xs-12 col-md-6 ">
									<div class="card card-success">
										<div class="card-header">
											<h4><span className="mr-2">EVC Meter Profile</span><BootstrapTooltip title='Find Data In gsm_consumer_device_index (EVC_MC_METER_TYPE)' placement='top'><span><i className='fas fa-info-circle info_circle'></i></span></BootstrapTooltip></h4>
										</div>
										<div class="card-body "
											style={{ position: "relative", paddingLeft: "0px", paddingRight: "0px", height: "395px" }}>
											{seriesMeter.length > 0 && categoryMeter.length >0 ? <ReactApexChart options={options3} type="pie" series={seriesMeter} height={"350"} /> : <div className="d-flex" style={{ justifyContent: 'center' }}><img class="loader_center text-center" src={loaderGif} /></div>}
										</div>
										<div className="tw-flex tw-justify-between tw-px-3">
											<p>Total Count : {sum(seriesMeter)} </p>
											<p>{'Pie chart(Dynamic)'} </p>
										</div>
									</div>
								</div> : ''}

								
								{permision?.ROLES_OTHER_PERMISSIONS?.GSM_GROUP_DASH?.MODEM?.view?.filter((item) => (item == 'Tags')).length > 0 || userInfo?.ROLE == 'ROLE1650614500708' ? <div class="col-xs-12 col-md-6 col-lg-6 col-xl-6 ">
									<div class="card card-danger">
										<div class="card-header">
											<h4><span className="mr-2">Tags</span><BootstrapTooltip title='Find Data In gsm_consumer_device_index (TAGS)' placement='top'><span><i className='fas fa-info-circle info_circle'></i></span></BootstrapTooltip></h4>
										</div>
										<div
											class="card-body"
											style={{ position: "relative", paddingLeft: "0px", paddingRight: "0px", height: "395px" }}>
											<ReactApexChart options={options8} type="pie" series={tagsCount.series} height={"350"} />

											{/* : <div className="d-flex" style={{ justifyContent: 'center' }}><img class="loader_center text-center" src={loaderGif} /></div>} */}
										</div>
										<div className="tw-flex tw-justify-between tw-px-3">
											<p>Total Count : {sum(tagsCount.series)}  </p>
											<p>{'Pie chart(Dynamic)'} </p>
										</div>
									</div>
								</div> : ''}

								<div class="col-12">
									<div class="card h-100 card-danger">
										<div class="row">
											<div class="card-header d-flex" style={{ justifyContent: 'space-between' }}>
												<h4>GSM Map</h4>
												<div >
													<a onClick={() => (inputSeen ? window.open(`/gsm-map-view?last_seen=${inputSeen}`, '_blank') : {})} class="btn btn-info text-white">View More</a>
												</div>
											</div>
											<div class="card-body" style={{ height: '500px', width: "100%" }}>
												<div class="map-inner" style={{ height: '500px', width: "100%" }}>
													{/*dev- AIzaSyD07E1VvpsN_0FvsmKAj4nK9GnLq-9jtj8 */}
													{/*server- AIzaSyAo0xl_P_6Ga-ee6ggeYe1JAE2jq3PxU5s */}
													<ArticlesMap
														googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyAo0xl_P_6Ga-ee6ggeYe1JAE2jq3PxU5s&v=3.exp&libraries=geometry,drawing,places"
														loadingElement={<div style={{ height: '100%', width: '100%' }} />}
														containerElement={<div style={{ height: '100%', width: '100%' }} />}
														mapElement={<div style={{ height: '100%', width: '100%' }} />}
														onClick={(ev) => { console.log(ev) }}
														mapInfo={mapInfo}
														curentpos={{ lat: 21.727293496271507, lng: 75.5823933220894 }}
													/>
													{/* <iframe src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d2965.0824050173574!2d-93.63905729999999!3d41.998507000000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sWebFilings%2C+University+Boulevard%2C+Ames%2C+IA!5e0!3m2!1sen!2sus!4v1390839289319" width="100%" height="300" frameborder="0"></iframe> */}
												</div>
											</div>
										</div>
									</div>
								</div>

							</div>
						</>)}
						
					</div>
				</section>
			</div >
		</>
	);
}

export const ArticlesMap = withScriptjs(withGoogleMap((props) => {
	console.log(props);
	const [jobDetail, setJobDetail] = useState({ activeMarker: {}, isOpen: false, Info: {} })
	const onMarkerClicked = (data, marker) => {
		console.log(data, marker);
		setJobDetail({
			activeMarker: { lat: data?.latLng?.lat(), lng: data?.latLng?.lng() },
			isOpen: true,
			Info: marker
		})
	}

	const onToggleOpen = () => {
		setJobDetail({ ...jobDetail, isOpen: false })
	}
	function getSecondsTodayBydate(ts) {
		var now = moment().add(-moment().utcOffset(), "m").format("DD/MM/YYYY HH:mm:ss");
		var then = moment.utc(ts).add(-moment().utcOffset(), "m").format("DD/MM/YYYY HH:mm:ss");
		return moment(now, "DD/MM/YYYY HH:mm:ss").diff(moment(then, "DD/MM/YYYY HH:mm:ss"), 'second')
	}
	return (<>
		<GoogleMap
			defaultZoom={5}
			defaultCenter={{ lat: props.curentpos.lat, lng: props.curentpos.lng }}
			onClick={(e) => { console.log("e.latLng.lat()", e.latLng.lat(), "e.latLng.lng()", e.latLng.lng()) }}
		>
			{props?.mapInfo?.map((item, id) => (<><Marker
				defaultZoomOnClick={4}
				icon={{
					url: (getSecondsTodayBydate(item.HEARTBEAT_TS) < 86400) ? mapicon : mapRedicon,
					scaledSize: new window.google.maps.Size(25, 25),

				}}
				defaultOptions={{ optimized: false }}
				onMouseOver={(data) => onMarkerClicked(data, item)}
				key={id}
				position={{ lat: parseFloat(item?.LATITUDE), lng: parseFloat(item?.LONGITUDE) }}
			/></>))}
		</GoogleMap>
		{jobDetail?.activeMarker?.lat && jobDetail.isOpen &&
			<InfoWindow position={{ lat: jobDetail?.activeMarker?.lat, lng: jobDetail?.activeMarker?.lng }} onCloseClick={onToggleOpen} options={{
				pixelOffset: new window.google.maps.Size(
					0, -15
				)
			}}>
				<div className="detailCard">
					<div className="d-flex main-div">
						<div className="d-inline-block">
							<div className="text-black name">{jobDetail?.Info?.address_compony_name}
							</div>
						</div>
					</div>
				</div>
			</InfoWindow>}
	</>
	);
}
))

